// import React from 'react';
import React, { useState, useEffect, useRef, useCallback } from "react";
// import { useDispatch } from 'react-redux'
// import { SMTPClient , Message } from 'emailjs';
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import { Link, useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Collapse } from "reactstrap";
import Theme from './Theme.js'
import { ColorPicker } from 'primereact/colorpicker';

// import { ColorPicker, useColor } from "react-color-palette";
// import "react-color-palette/css";


import QRCode from "qrcode.react";
import Select from "react-select";
import jsPDF from "jspdf";
import Config from "../../Config.js";
import swal from "sweetalert";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
import { useAuth0 } from "@auth0/auth0-react";
import DataTable from "react-data-table-component";
import { CheckCheckAPDynamicQrCodeCountenabled } from "../../api/packageApi";
import {
  GetDominUrl
} from "../../api/apiconfiguration.js";

// import EmailShare from 'react-email-share-link';
import { Checkexportdata } from "../../api/packageApi";
require("codemirror/mode/xml/xml.js");
require("codemirror/mode/javascript/javascript.js");

const ArticleQRCode = (props) => {
  let history = useHistory();
  const [rolename, setroleName] = useState(
    localStorage.getItem("loginRoleName")
  );
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const { user } = useAuth0();
  const [ArticlesList, setArticlesList] = useState([]);
  const [SelectedArticlesList, setSelectedArticlesList] = useState([]);
  const [PaggingList, setPaggingList] = useState([]);
  const [ArticleSKUError, setArticleSKUError] = useState("");
  const [ArticleSKU, setArticleSKU] = useState("");
  const [IsPublished, setIsPublished] = useState("");
  const [CategoryId, setCategoryId] = useState("");
  const [CategoryError, setCategoryError] = useState("");
  const [ArticleTypeError, setArticleTypeError] = useState("");
  const [ArticlesTypeId, setArticlesTypeId] = useState("");
  const [SupplierError, setSupplierError] = useState("");
  const [SupplierId, setSupplierId] = useState("");
  const [ArticleNameError, setArticleNameError] = useState("");
  const [ArticleName, setArticleName] = useState("");
  const [LabelError, setLabelError] = useState("");
  const [Isloading, setIsloading] = useState(false);
  const [LabelId, setLabelId] = useState("");

  const [Qrcodestring, setQrcodestring] = useState("");
  const [QrcodeProductname, setQrcodeProductname] = useState("");
  const [variationlistmodal, setvariationlistmodal] = useState(false);
  //DropDown
  const [LabelList, setLabelList] = useState([]);
  const [CategoryList, setCategoryList] = useState([]);
  const [ArticlesTypeList, setArticlesTypeList] = useState([]);
  const [SupplierList, setSupplierList] = useState([]);

  //pagination
  const [PerPageCount, setPerPageCount] = useState(10);
  const [TotalCount, setTotalCount] = useState(0);
  const [TotleCountPublished, setTotleCountPublished] = useState(0);
  const [SortColumnType, setSortColumnType] = useState("Desc");
  const [SortColumn, setSortColumn] = useState("createdDate");
  const [SearchValue, setSearchValue] = useState("");
  const [CurrentPageNo, setCurrentPageNo] = useState(1);
  const [ShowPaggingCount, setShowPaggingCount] = useState(4);
  const [PaginationGroupList, setPaginationGrouplist] = useState([]);
  const [canPreviousPage, setcanPreviousPage] = useState(false);
  const [canNextPage, setcanNextPage] = useState(true);
  const [modal3, setmodal3] = useState(false);
  const [modalArticleQroce, setmodalArticleQroce] = useState(false);

  const [Editshowornot, setEditshowornot] = useState(false);
  // const [skipPageReset, setSkipPageReset] = React.useState(false)

  const [ArticlesNo, setArticlesNo] = useState("");
  const [ArticlesName, setArticlesName] = useState("");
  const [ArticlescategoryName, setArticlescategoryName] = useState("");
  const [ArticlessubcategoryName, setArticlessubcategoryName] = useState("");
  const [ArticlesProfileImage, setArticlesProfileImage] = useState("");
  const [selectedData, setSelectedData] = React.useState([]);
  const [ArticlesVariationList, setArticlesVariationList] = useState([]);
  const [selectArticleProductinfo, setselectArticleProducinfo] = useState(null);

  const [subcategoryId, setsubcategoryId] = useState("");
  const [subcategoryIdError, setsubcategoryIdError] = useState("");
  const [issubcategoryshow, setissubcategoryshow] = useState(false);
  const [subcetgoryList, setsubcetgoryList] = useState([]);

  const [userLoaded, setUserLoaded] = useState(false);

  const [QrCodeModalisOpen, setQrCodeModalisOpen] = useState(false);

  const [selectCombinationID, setselectCombinationID] = useState("");
  const [selectCombination, setselectCombination] = useState("");
  const [QrCodeString, setQrCodeString] = useState("");
  const [ArticleId, setArticleId] = useState("");

  const [subuserlist, setsubuserlist] = useState([]);
  const [selectuserID, setselectuserID] = useState("");
  const [selectuseronlyID, setselectuseronlyID] = useState("");

  const [subToEmail, setsubToEmail] = useState([]);
  const [isToEamil, setisToEamil] = useState(false);
  const [isToEamilAttribute, setisToEamilAttribute] = useState(false);

  const [ToemailEmptyError, setToemailEmptyError] = useState("");
  const [isToemailMaltiple, setisToemailMaltiple] = useState(false);

  const inputOpenFileRef = React.createRef();
  // const [Auth0token , setAuth0token] = useState(localStorage.getItem('Auth0token'))

  //preview states
  // const [radiusSliderimg, setRadiusSliderimg] = useState(16);
  const [PreviewModalisOpen, setPreviewModalisOpen] = useState(false);

  const [titlefontsize, settitlefontsize] = useState(16);
  const [titlefontsizeFinal, settitlefontsizeFinal] = useState("16Px");
  const [IsBackgroundUrl, setIsBackgroundUrl] = useState(false);
  const [selectedOptionBackgroundColor, setselectedOptionBackgroundColor] = useState(false);
  const [descriptionfontsize, setdescriptionfontsize] = useState(16);
  const [descriptionfontsizeFinal, setdescriptionfontsizeFinal] = useState("16px");
  const [ckeditorTitleFontSize, setCkeditorTitleFontSize] = useState(16);
  const [ckeditorTitleFontSizeFinal, setCkeditorTitleFontSizeFinal] = useState("16px");
  const [ckeditorDescriptionFontSize, setCkeditorDescriptionFontSize] = useState(16);
  const [ckeditorDescriptionFontSizeFinal, setCkeditorDescriptionFontSizeFinal] = useState("16px");
  const [pageBackgroundImage, setpageBackgroundImage] = useState('');

  const [productinfo, setproductinfo] = useState(null);
  const [isLoading, setisLoading] = useState(false);
  const [Collapseidlist, setCollapseidlist] = useState([]);
  const [defaultThemelistTemp, setDefaultThemelistTemp] = useState([]);
  const [defaultThemelist, setDefaultThemelist] = useState([]);
  const [uploadBackgroundImage, setuploadBackgroundImage] = useState(null);
  const [productQrcodeThemeId, setProductQrcodeThemeId] = useState("");
  const [defaultThemeId, setDefaultThemeId] = useState("");
  const [Color1, setColor1] = useState("#0a0303");
  const [Color2, setColor2] = useState("#01F9C6");
  const [Color3, setColor3] = useState("#617C58");
  // const [Color2, setColor2] = useColor("#01F9C6");

  const [Sliderimground, setSliderimground] = useState("");
  const [isbuttonLoading, setisbuttonLoading] = useState(false);
  const [logoshadow, setlogoshadow] = useState(1);
  const [logoshadowFinal, setlogoshadowFinal] = useState("1px",);
  const [iscertificatesopen, setiscertificatesopen] = useState(false);

  const [issuccess, setissuccess] = useState(false);
  const [iserror, setiserror] = useState(false);
  const domainFrontUrl = useRef("");

  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    } else {
      getDominUrl();
      // GetAllDropdwonArticle();
      GetalldefaultTheme();
      // GetAllCategory();
      if (rolename === "Admin" || rolename === "SuperAdmin") {
        GetadminaandAllsubuser();

      }
    }
  }, []);

  const getDominUrl = async () => {
    let response = await GetDominUrl();
    if (response !== null && response.domainName !== null && response.domainName !== "") {
      domainFrontUrl.current = response.domainName;
    }
    else {
      domainFrontUrl.current = "";
    }
  }
  useEffect(() => {
    setPaggingDDL();
    getPaginationGroup();
  }, [TotalCount]);

  // const CheckAddArticleProduct = async () => {
  //     console.log("button clicked new")
  //     let loginid = localStorage.getItem("loginUserID");
  //     let Auth0token = localStorage.getItem('Auth0token')
  //     return await fetch(Config.apiUrl + "Package/CheckQrcodeArticleProduct?UserCompanyId=" + loginid, {
  //         method: "GET",
  //         headers: {
  //             "Content-Type": "application/json",
  //             "userCompanyID": loginid,
  //             Authorization: 'Bearer ' + Auth0token,
  //         },
  //     }).then((resp1) => {
  //         resp1.json().then((result) => {
  //             return result;
  //         });
  //     });
  // }

  const toggleArticle = (Qrcodepath) => {
    if (modalArticleQroce === false) {
      // setQrcodestring(Config.FrontUrl+ Qrcodepath.qrCodePath);
      let qrcodestring = domainFrontUrl.current + Qrcodepath.qrCodePath;
      setQrcodestring(qrcodestring);
      setQrcodeProductname(Qrcodepath.articleName);
    } else {
      setQrcodestring("");
      setQrcodeProductname("");
    }
    setmodalArticleQroce(!modalArticleQroce);
  };
  const toggleToEmail = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamil(!isToEamil);
  };
  const toggleToEmailAttributecreate = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamilAttribute(!isToEamilAttribute);
  };

  const toggleArticleVariant = (row) => {
    if (modalArticleQroce === false) {
      let attribute = "";
      if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 !== "" &&
        row.attributeValue4 !== "" &&
        row.attributeValue5 !== ""
      ) {
        attribute =
          row.attributeValue1 +
          "/" +
          row.attributeValue2 +
          "/" +
          row.attributeValue3 +
          "/" +
          row.attributeValue4 +
          "/" +
          row.attributeValue5;
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 !== "" &&
        row.attributeValue4 !== "" &&
        row.attributeValue5 === ""
      ) {
        attribute =
          row.attributeValue1 +
          "/" +
          row.attributeValue2 +
          "/" +
          row.attributeValue3 +
          "/" +
          row.attributeValue4;
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 !== "" &&
        row.attributeValue4 === "" &&
        row.attributeValue5 === ""
      ) {
        attribute =
          row.attributeValue1 +
          "/" +
          row.attributeValue2 +
          "/" +
          row.attributeValue3;
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 !== "" &&
        row.attributeValue3 === "" &&
        row.attributeValue4 === "" &&
        row.attributeValue5 === ""
      ) {
        attribute = row.attributeValue1 + "/" + row.attributeValue2;
      } else if (
        row.attributeValue1 !== "" &&
        row.attributeValue2 === "" &&
        row.attributeValue3 === "" &&
        row.attributeValue4 === "" &&
        row.attributeValue5 === ""
      ) {
        attribute = row.attributeValue1;
      }
      let qrcodestring = domainFrontUrl.current + row.qrCode;
      // setQrcodestring(row.qrCode);
      setQrcodestring(qrcodestring);
      setQrcodeProductname(attribute);
    } else {
      setQrcodestring("");
      setQrcodeProductname("");
    }
    setmodalArticleQroce(!modalArticleQroce);
  };

  useEffect(() => {
    getData();
  }, [PerPageCount, SortColumnType, CurrentPageNo, userLoaded]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Sr. #",
        accessor: "sr",
        selector: "sr",
        sortable: false,
        Cell: (row) => {
          {
            return <span>{row?.row?.original?.sr}</span>;
          }
        },
      },
      {
        Header: "Image",
        accessor: "articleImage",
        selector: "ArticleImage",
        sortable: false,
        Cell: (row) => {
          let FullPath = `${Config.contentUrl + row?.row?.original?.articlePics
            }`;
          {
            return row?.row?.original?.articlePics !== null &&
              row?.row?.original?.articlePics !== undefined&&
            row?.row?.original?.articlePics !== "" ? (
              <img
                src={FullPath}
                className="table-main-image btn-shadow"
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = "../assets/img/new-images/images.png";
                }}
                onClick={(e) => {
                  GoToProductinformationPage(row.row.original._id);
                }}
              ></img>
            ) : (
              <img
                src="../assets/img/new-images/images.png"
                style={{ height: "50px", cursor: "pointer", width: "50px" }}
                onClick={(e) => {
                  GoToProductinformationPage(row.row.original._id);
                }}
              ></img>
            );
          }
        },
      },
      {
        Header: "Name",
        accessor: "articleName",
        selector: "articleName",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          {
            return row?.row?.original?.articleName != null &&
              row?.row?.original?.articleName != "" ? (
              // <p>{row.row.original.articleType.name}</p>
              <div className="articletypebtn">
                <div className="data-scroll">
                  <p className="mb-0">{row?.row?.original?.articleName}</p>
                </div>
              </div>
            ) : (
              <div className="articletypebtn">
                <div className="data-scroll">
                  <p className="mb-0">N/A</p>
                </div>
              </div>
            );
          }
        },
      },
      {
        Header: "QR Code",
        accessor: "articleQrcode",
        selector: "articleQrcode",
        sortable: false,
        Cell: (row) => {
          return row?.row?.original?.qrCodePath !== null &&
            row?.row?.original?.qrCodePath !== "" &&
            row?.row?.original?.qrCodePath !== undefined ? (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border " +
                  (row?.row?.original?.isPublished === false
                    ? "border-danger"
                    : "")
                }
                onClick={() => {
                  toggleArticle(row?.row?.original);
                }}
              >
                <img
                  src="../assets/img/user/QR.png"
                  alt="img"
                  style={{ height: "40px", width: "40px" }}
                  //onerror="this.src='../assets/img/new-images/images.png';"
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>
                  {row?.row?.original?.isPublished === false ? "Pause" : "Play"}
                </b>
              </p>
            </div>
          ) : row?.row?.original?.isshow === true ? (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border " +
                  (row.row.original.isPublished === false
                    ? "border-danger"
                    : "")
                }
                onClick={(e) => {
                  EditArticleDetails(row?.row?.original?._id);
                }}
              >
                <img
                  src="/assets/img/new-Images/qr-code-scanner.jpg"
                  style={{ height: "40px", width: "40px" }}
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>
                  {row?.row?.original?.isPublished === false ? "Pause" : "Play"}
                </b>
              </p>
            </div>
          ) : (
            <>
              <div>
                <button
                  className={
                    "m-t-5 btn btn-white btn-shadow p-2 border " +
                    (row.row.original.isPublished === false
                      ? "border-danger"
                      : "")
                  }
                  onClick={(e) => {
                    swal("  Oops... not allowed ! ");
                  }}
                >
                  <img
                    src="/assets/img/new-Images/qr-code-scanner.jpg"
                    style={{ height: "40px", width: "40px" }}
                  ></img>
                </button>
                <p className="small text-center m-t-5">
                  <b>
                    {row?.row?.original?.isPublished === false
                      ? "Pause"
                      : "Play"}
                  </b>
                </p>
              </div>
            </>
          );
        },
      },

      {
        Header: "Total Scans",
        accessor: "totalScans",
        selector: "totalScans",
        sortable: true,
        headerClassName: "rt-tr-align-right",
        Cell: (row) => {
          {
            return row?.row?.original?.totalScans != null &&
              row?.row?.original?.totalScans != "" ? (
              <div className="">
                <p className="m-0">
                  {row?.row?.original?.totalScans
                    ? row?.row?.original?.totalScans
                    : "0"}
                </p>
              
                {row?.row?.original?.isshow === true ? (
                  <button
                    className="btn btn-link"
                    // onClick={() => {
                    //   gotoreports(row?.row?.original?._id);
                    // }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                ) : (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      swal("Oops... not allowed ! ");
                    }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                )}
              </div>
            ) : (
              <div className="">
                <p className="m-0">0</p>
                {row?.row?.original?.isshow === true ? (
                  <button
                    className="btn btn-link"
                    // onClick={() => {
                    //   gotoreports(row?.row?.original?._id);
                    // }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                ) : (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      swal("Oops... not allowed ! ");
                    }}
                  >
                    <img
                      src="../assets/img/user/graph.png"
                      style={{ height: "30px" }}
                    ></img>
                  </button>
                )}
              </div>
            );
          }
        },
      },

      // {
      //   Header: "Article",
      //   accessor: "articleNumber",
      //   selector: "articleNumber",
      //   sortable: true,
      //   headerClassName: "rt-tr-align-right",
      //   Cell: (row) => {
      //     {
      //       return row?.row?.original?.articleNumber != null &&
      //         row?.row?.original?.articleNumber != "" ? (
      //         <div className="data-scroll">
      //           <p className="mb-0">{row?.row?.original?.articleNumber}</p>
      //         </div>
      //       ) : (
      //         ""
      //       );
      //     }
      //   },
      // },
     
      // {
      //   Header: "Category",
      //   accessor: "category",
      //   selector: "category",
      //   sortable: true,
      //   headerClassName: "rt-tr-align-right",
      //   Cell: (row) => {
      //     //let FullPathQrcode = `${row.row.original.categorydetail.name}`;
      //     {
      //       return row?.row?.original?.categorydetail?._id != null &&
      //         row?.row?.original?.categorydetail?._id != "" ? (
      //         <p>
      //           {row?.row?.original?.categorydetail?.name}
      //           {row?.row?.original?.subCategoryDetail?._id != null &&
      //             row?.row?.original?.subCategoryDetail?._id != "" ? (
      //             <p>/ {row?.row?.original?.subCategoryDetail?.name}</p>
      //           ) : (
      //             ""
      //           )}
      //         </p>
      //       ) : (
      //         ""
      //       );
      //     }
      //   },
      // },
      {
        Header: " Created date",
        accessor: "createdDate",
        selector: "createdDate",
        sortable: true,
        Cell: (row) => {
          let date = new Date(row?.row.original?.createdDate);
          let dateMDY = `${date.getDate()}-${date.getMonth() + 1
            }-${date.getFullYear()}`;
          return <span>{dateMDY}</span>;
        },
      },
      // {
      //   Header: "Owner",
      //   accessor: "Owner",
      //   selector: "Owner",
      //   sortable: false,
      //   Cell: (row) => {
      //     let FullOwnerpath = `${Config.contentUrl + row.row.original.ownerImage
      //       }`;
      //     return (
      //       //<img src={FullPathQrcode} alt="img" style={{ height: '40px' }}></img>
      //       <div className="data-scroll">
      //         <img
      //           src={FullOwnerpath}
      //           className="rounded-circle"
      //           style={{ height: "40px", width: "40px", objectFit: "cover" }}
      //           // onError={({ currentTarget }) => {
      //           //   currentTarget.onerror = null; // prevents looping
      //           //   currentTarget.src = "../assets/img/new-images/images.png";
      //           // }}
      //         ></img>
      //         {/* <img src="../assets/img/user/user-1.jpg" alt="img" style={{ height: '40px', }} className='rounded-circle'></img> */}
      //         <p>{row.row.original.ownerName}</p>
      //       </div>
      //     );
      //   },
      // },
      {
        Header: " Actions",
        accessor: "col13",
        sortable: false,
        Cell: (row) => {
          return (
            <div style={{ width: "100%" }}>
              {row?.row?.original?.isshow === true ? (
                <>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mr-2 mt-2"
                    onClick={(e) => {
                      EditArticleDetails(row?.row?.original?._id);
                    }}
                  >
                    <i className="ion ion-md-create "></i>
                  </button>
                  {row?.row?.original?.qrCodePath !== null &&
                    row?.row?.original?.qrCodePath !== "" ? (
                    <UncontrolledButtonDropdown>
                      <DropdownToggle className="btn btn-warning ellipsis-btn btn-sm  mt-2">
                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          onClick={(e) => {
                            row?.row?.original?.isPublished === false
                              ? ArticlePlay(row?.row?.original?._id)
                              : ArticlePlayAllreadyplay();
                          }}
                        >
                          <i className="fas fa-play m-r-10"></i>
                          Play
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem
                          onClick={(e) => {
                            row?.row?.original?.isPublished === false
                              ? ArticlePlayAllreadypush()
                              : ArticlePause(row?.row?.original?._id);
                          }}
                        >
                          <i className="fas fa-pause m-r-10"></i>
                          Pause
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem
                          className="text-danger"
                          onClick={(e) => {
                            DeleteArticleDetails(row.row.original._id);
                          }}
                        >
                          <i className="fas fa-trash m-r-10"></i>
                          Delete
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  ) : (
                    <UncontrolledButtonDropdown>
                      <DropdownToggle className="btn btn-warning ellipsis-btn btn-sm mt-2">
                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          onClick={(e) => {
                            swal("Oops... Your Qrcode Not Generate ! ");
                          }}
                        >
                          <i className="fas fa-play m-r-10"></i>
                          Play
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem
                          onClick={(e) => {
                            swal("Oops... Your Qrcode Not Generate ! ");
                          }}
                        >
                          <i className="fas fa-pause m-r-10"></i>
                          Pause
                        </DropdownItem>
                        <DropdownItem divider></DropdownItem>
                        <DropdownItem
                          className="text-danger"
                          onClick={(e) => {
                            DeleteArticleDetails(row.row.original._id);
                          }}
                        >
                          <i className="fas fa-trash m-r-10"></i>
                          Delete
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  )}
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mr-2"
                    onClick={(e) => {
                      swal("  Oops... not allowed ! ");
                    }}
                  >
                    <i className="ion ion-md-create "></i>
                  </button>
                  <UncontrolledButtonDropdown>
                    <DropdownToggle className="btn btn-warning ellipsis-btn btn-sm">
                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={(e) => {
                          swal("  Oops... not allowed ! ");
                        }}
                      >
                        <i className="fas fa-play m-r-10"></i>
                        Play
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          swal("  Oops... not allowed ! ");
                        }}
                      >
                        <i className="fas fa-pause m-r-10"></i>
                        Pause
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        className="text-danger"
                        onClick={(e) => {
                          swal("  Oops... not allowed ! ");
                        }}
                      >
                        <i className="fas fa-trash m-r-10"></i>
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledButtonDropdown>
                </>
              )}

              <button
                type="button"
                className="btn btn-info btn-sm  ml-2 mt-2"
                onClick={(e) => {
                  togglepreviewModal(row?.row?.original?._id);
                }}
              >
                <i className="ion ion-md-color-palette"></i>
              </button>
            </div>
          );
        },
      },
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,

    //canPreviousPage,
    //canNextPage,
    pageOptions,

    //gotoPage,
    //nextPage,

    //setPageSize,
    //state: { pageIndex, pageSize },
    toggleAllRowsSelected,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data: ArticlesList,
      manualPagination: true,
      sortable: false,
      manualSortBy: true,
    },
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          _id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );
  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);

      return (
        <>
          <input type="checkbox" ref={resolvedRef} {...rest} />
        </>
      );
    }
  );
  const onChangeArticleSKU = (event) => {
    setArticleSKUError("");
    setArticleSKU(event.target.value);
  };
  const onChangeSubCategory = (event) => {
    setsubcategoryId(event.target.value);
    setsubcategoryIdError("");
  };
  const onChangePublished = (event) => {
    console.log(event.target.value);
    setIsPublished(event.target.value);
  };
  const handleChangeCategory = () => {
    if (issubcategoryshow === true) {
      setsubcategoryId("");
    }
    setissubcategoryshow(!issubcategoryshow);
  };

  const onChangeCategory = (event) => {
    let catId = event.target.value;
    setCategoryId(event.target.value);
    setCategoryError("");
    if (CategoryList.length > 0);
    {
      var subCategoryDetailList = CategoryList.find(
        (x) => x._id === event.target.value
      );
      if (subCategoryDetailList != undefined) {
        setsubcetgoryList(subCategoryDetailList.subCategoryModelList);
      } else {
        setsubcetgoryList([]);
      }
    }
  };

  const onChangeArticledroptype = (event) => {
    let artId = event.target.value;
    setArticleTypeError("");
    setArticlesTypeId(event.target.value);
  };

  const onChangeSupplierdroptype = (event) => {
    let suplierId = event.target.value;
    setSupplierError("");
    setSupplierId(event.target.value);
  };

  const onChangeArticleName = (event) => {
    setArticleNameError("");
    setArticleName(event.target.value);
  };

  const onChangeLabeldrop = (event) => {
    let lablId = event.target.value;
    setLabelError("");
    setLabelId(event.target.value);
  };

  const gotoPage = () => {
    if (CurrentPageNo > 1) {
      setCurrentPageNo((CurrentPageNo) => CurrentPageNo - 1);
      let temp = Math.ceil(CurrentPageNo - 1);
      if (temp === 1) {
        setcanPreviousPage(false);
      } else {
        setcanPreviousPage(true);
        setcanNextPage(true);
      }
    }
  };

  const nextPage = () => {
    setCurrentPageNo((CurrentPageNo) => CurrentPageNo + 1);
    setcanPreviousPage(true);
    let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
    let temp = Math.ceil(CurrentPageNo + 1);
    if (temp === PerPageCountobj) {
      setcanNextPage(false);
    }
  };

  // const EditArticleDetails = (ArticleIdObj) => {
  //     if (ArticleIdObj === '') {
  //         props.history.push('Login1');
  //     }
  //     else {
  //         props.history.push({ pathname: 'addnewarticle', state: { EditArticleDetailsID: ArticleIdObj } });
  //         //props.history.push('addnewarticle');
  //         //props.history.push('Login1');
  //     }

  // }
  const gotoreports = (articleID) => {
    // history.push({
    //   pathname: "/dashboard/reports",
    //   state: { ActivePill: "1", ArticleID: articleID },
    // });
    history.push({
      pathname: "/reports",
      state: { ActivePill: "1", ArticleID: articleID },
    });
  };
  const gotoreportsAttribute = (row) => {
    console.log("row", row);
    // history.push({
    //   pathname: "/dashboard/reports",
    //   state: { ActivePill: "1" },
    // });
    history.push({
      pathname: "/reports",
      state: { ActivePill: "1" },
    });
  };
  const createQrcode = () => {
    swal("Sorry!", "pleace Create Qrcode", "error");
  };

  const AddArticleDetails = (ArticleIdObj) => {
    history.push({
      pathname: "/article-addnew",
      state: { EditArticleDetailsID: ArticleIdObj },
    });
  };
  const EditArticleDetails = (ArticleIdObj) => {
    console.log("ArticleIdObj", ArticleIdObj);
    if (ArticleIdObj === "") {
      props.history.push("Login1");
    } else {
      history.push({
        pathname: "/article-addnew",
        state: { EditArticleDetailsID: ArticleIdObj },
      });
    }
  };
  const getPaginationGroup = () => {
    if (TotalCount > 0) {
      let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
      let start = Math.floor((CurrentPageNo - 1) / PerPageCount) * PerPageCount;
      let LastPageNo = Math.ceil(TotalCount / PerPageCount);
      if (PerPageCountobj === 1) {
        setcanPreviousPage(false);
        setcanNextPage(false);
      }
      let testArray = [];
      for (var tt = 1; tt <= TotalCount; tt++) {
        if (
          tt >= CurrentPageNo - ShowPaggingCount &&
          tt <= CurrentPageNo + ShowPaggingCount
        ) {
          if (tt <= LastPageNo) {
            testArray.push(tt);
          }
        }
      }
      setPaginationGrouplist(testArray);
    }
  };
  const setPaggingDDL = () => {
    var testDDL = [];

    if (TotalCount <= 10) {
      testDDL = [10, TotalCount];
    } else if (TotalCount <= 20) {
      testDDL = [10, 20, TotalCount];
    } else if (TotalCount <= 30) {
      testDDL = [10, 20, 30, TotalCount];
    } else if (TotalCount <= 50) {
      testDDL = [10, 20, 30, 50, TotalCount];
    } else if (TotalCount <= 100) {
      testDDL = [10, 20, 30, 50, 100, TotalCount];
    } else if (TotalCount <= 200) {
      testDDL = [10, 20, 30, 50, 100, 200, TotalCount];
    } else if (TotalCount <= 300) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, TotalCount];
    } else if (TotalCount <= 400) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, 400, TotalCount];
    } else if (TotalCount <= 500) {
      testDDL = [10, 20, 30, 50, 100, 200, 300, 400, 500, TotalCount];
    }

    setPaggingList(testDDL);
  };
  useEffect(() => {
    // action on update of movies
    console.log("CurrentPageNo-", CurrentPageNo);
  }, [CurrentPageNo]);
  const changePage = (event) => {
    const pageNumber = Number(event.target.textContent);
    //setCurrentPageNo(pageNumber);
    setCurrentPageNo(pageNumber);
    if (pageNumber === 1) {
      setcanPreviousPage(false);
      setcanNextPage(true);
    } else {
      setcanPreviousPage(true);
    }
    // setCurrentPageNo(pageNumber);
    let PerPageCountobj = Math.ceil(TotalCount / PerPageCount);
    if (pageNumber === PerPageCountobj) {
      setcanNextPage(false);
    } else {
      setcanNextPage(true);
    }
  };
  const handlePageCountChange = (event) => {
    setPerPageCount(event);
    setCurrentPageNo(1);
    if (event >= TotalCount) {
      setcanPreviousPage(false);
      setcanNextPage(false);
    } else {
      setcanPreviousPage(false);
      setcanNextPage(true);
    }
  };

  //Rajani start
  const getData = () => {
    setPaginationGrouplist([]);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let subUserIDList = localStorage.getItem("subUserIDList");
    // setIsloading(true)
    // document.body.style.overflow = "hidden";
    setTotalCount(0);
    setArticlesList([]);
    fetch(
      Config.apiUrl +
      "ArticleProduct/Pagination?SortingColumnName=" +
      SortColumn +
      "&AscDesc=" +
      SortColumnType +
      "&PageNo=" +
      CurrentPageNo +
      "&PageSize=" +
      PerPageCount +
      "&SearchQuery=" +
      SearchValue +
      "&articleName=" +
      ArticleName +
      "&categoryId=" +
      CategoryId +
      "&subcategoryId=" +
      subcategoryId +
      "&labelId=" +
      LabelId +
      "&supplierId=" +
      SupplierId +
      "&articleTypeId=" +
      ArticlesTypeId +
      "&isPublished=" +
      IsPublished +
      "&user=" +
      selectuseronlyID +
      "&sku=" +
      ArticleSKU,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          subUserCompanyID: subUserIDList,
          Authorization: "Bearer " + Auth0token,
        },
      }
    )
      .then((resp1) => {
        resp1.json().then((result) => {
          console.log("resulyPraveen=>", result);
          if (result !== null) {
            if (result.totalCount != 0) {
              setTotalCount(result.totalCount);
              setArticlesList(result.articleProductList);
              setTotleCountPublished(result?.totalPublishedCount);
            } else {
              setTotalCount(0);
              setArticlesList([]);
              setTotleCountPublished(0);
              setEditshowornot(false);
            }
          } else {
            setTotalCount(0);
            setArticlesList([]);
            setTotleCountPublished(0);
            setEditshowornot(false);
          }
          // setIsloading(false)
          // document.body.style.overflow = 'auto';
        });
      })
      .catch((error) => {
        // setIsloading(false)
        // document.body.style.overflow = 'auto';
        console.error("There was an error!", error);
      });
  };
  const handleColumnSort = (event) => {
    setCurrentPageNo(1);
    setcanPreviousPage(false);
    setcanNextPage(true);
    setSortColumn(event.selector);
    let SortType = "Desc";
    if (SortColumnType == "Desc") {
      SortType = "Asc";
    }
    setSortColumnType(SortType);
  };
  const SearchFilter = () => {
    setCurrentPageNo(1);
    getData();
  };
  const ClereHedersearch = async (e) => {
    e.preventDefault();
    setArticleSKUError("");
    setArticleSKU("");
    setCategoryError("");
    setCategoryId("");
    setLabelError("");
    setLabelId("");
    setSupplierError("");
    setSupplierId("");
    setArticleTypeError("");
    setArticlesTypeId("");
    setArticleNameError("");
    setArticleName("");
    setIsPublished("");
    setsubcategoryId("");
    setsubcetgoryList([]);
    setissubcategoryshow(false);
    setselectuseronlyID("");
    setselectuserID("");
    setUserLoaded(!userLoaded);
    // getData();

    // setTimeout(() => {  getData(); }, 2000);
  };
  const ArticleDetailsSearch = (itemSearchValue) => {
    const itemlength = itemSearchValue.length;
    if (itemlength > 2) {
      getData();
    }
  };
  const GetAllDropdwonArticle = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let subUserIDList = localStorage.getItem("subUserIDList");
    let EmaptyArrry = [];

    fetch(Config.apiUrl + "ArticleProduct/AllDropdwon", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        subUserCompanyID: subUserIDList,
        Authorization: "Bearer " + Auth0token,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error(response.json());
      })
      .then((result) => {
        //Do something with the response
        if (result !== null && result !== "") {
          if (result?.labelDetail.length > 0) {
            setLabelList(result.labelDetail);
          } else {
            setLabelList(EmaptyArrry);
          }

          // if (result?.categorydetail.length > 0) {
          //     setCategoryList(result.categorydetail);
          // }
          // else {
          //     setCategoryList(EmaptyArrry);
          // }

          if (result?.articletype.length > 0) {
            setArticlesTypeList(result.articletype);
          } else {
            setArticlesTypeList(EmaptyArrry);
          }

          // if (result?.supplierdetail.length > 0) {
          //     setSupplierList(result.supplierdetail);
          // }
          // else {
          //     setSupplierList(EmaptyArrry);
          // }
        }
      })
      .catch((error) => {
        console.log("860", error);
      });
  };
  const GetAllCategory = () => {
    let loginid = localStorage.getItem("loginUserID");
    let EmaptyArrry = [];
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(Config.apiUrl + "Category/CategoryListwithsubcategory", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result.length > 0) {
          setCategoryList(result);
        } else {
          setCategoryList(EmaptyArrry);
        }
      });
    });
  };
  const GetadminaandAllsubuser = async () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "UserCompany/GetadminaandAllsubuser?isadmin=" + false,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((responseJson) => {
        setsubuserlist(responseJson);
      })
      .catch((error) => {
        // setIsloading(false)
        // document.body.style.overflow = 'auto';
        console.log(error);
        setsubuserlist([]);
      });
  };
  const handleAdd = (id) => {
    let temp = SelectedArticlesList;
    temp.push(id);
    setSelectedArticlesList(temp);
  };
  const handleRemove = (id) => {
    let temp = SelectedArticlesList;
    let toRemove = id;
    let index = temp.indexOf(toRemove);
    if (index > -1) {
      temp.splice(index, 1);
      setSelectedArticlesList(temp);
    }
  };
  const handleArticlesList = (ArticleData) => {
    let emptyarry = [];
    setArticlesList(emptyarry);
    let temp = ArticleData;
    setArticlesList(ArticleData);
    let temp1 = ArticlesList;
  };

  const ExportDeatlis = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    let TotalIteam = [];
    for (let index = 0; index < selectedFlatRows.length; index++) {
      TotalIteam.push(selectedFlatRows[index].original._id);
    }
    if (TotalIteam.length > 0) {
      fetch(Config.apiUrl + "ArticleProduct/Export", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(TotalIteam),
      })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = "ExportArticle.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();
          deselectAllRows();
        });
    } else {
      swal("Sorry!", "pleace select articles !", "error");
    }
  };
  const deselectAllRows = useCallback(() => {
    Object.keys(selectedRowIds).forEach((key, index) => {
      selectedRowIds[key] = false;
    });
    toggleAllRowsSelected(false);
  }, [selectedRowIds, toggleAllRowsSelected]);

  const onSelcetdArticleDelete = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let TotalIteam = [];
    for (let index = 0; index < selectedFlatRows.length; index++) {
      if (selectedFlatRows[index].original?.isshow === true) {
        TotalIteam.push(selectedFlatRows[index].original._id);
      } else {
        swal("Oops... not allowed ! ");
        return;
      }
    }
    if (TotalIteam.length > 0) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this Article !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(
            Config.apiUrl + "ArticleProduct/MultipleDelete?id[]=" + TotalIteam,
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(TotalIteam),
            }
          ).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                getData();
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Article  is safe!");
              }
            });
          });
        }
      });
    } else {
      swal("Sorry!", "pleace select articles !", "error");
    }
  };
  const DeleteArticleDetails = (seleteArticleID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteArticleID != null &&
      seleteArticleID != "" &&
      seleteArticleID != undefined
    ) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this Article !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "ArticleProduct/Delete?id=" + seleteArticleID, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                getData();
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Article  is safe!");
              }
            });
          });
        }
      });
    }
  };
  const ArticlePlayAllreadyplay = () => {
    swal("Your Article already Play !");
  };
  const ArticlePlayAllreadypush = () => {
    swal("Your Article already push !");
  };
  const ArticlePlay = (seleteArticleID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteArticleID != null &&
      seleteArticleID != "" &&
      seleteArticleID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdateArticlePublish?id=" +
        seleteArticleID +
        "&isPublish=" +
        true,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            // ClereHedersearch()
            getData();
            swal("Congratulations! Your Article is Play successfully.", {
              icon: "success",
            });
          } else {
            swal("Your Article  Your Article not Play successfully.!");
          }
        });
      });
    }
  };
  const ArticlePause = (seleteArticleID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteArticleID != null &&
      seleteArticleID != "" &&
      seleteArticleID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdateArticlePublish?id=" +
        seleteArticleID +
        "&isPublish=" +
        false,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            // ClereHedersearch()
            getData();
            swal("Congratulations! Your Article is Pause successfully.", {
              icon: "success",
            });
          } else {
            swal("Your Article  Your Article not Pause successfully.!");
          }
        });
      });
    }
  };
  const onImportFileSelcetd = () => {
    inputOpenFileRef.current.click();
  };
  const ImportArticlefile = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let filetemp = e.target.files[0];
    if (e.target.files.length > 0) {
      const FileNameObj = filetemp.name.substring(
        filetemp.name.lastIndexOf(".") + 1
      );
      if (
        FileNameObj === "xlsx" ||
        FileNameObj === "xlsm" ||
        FileNameObj === "xlsb" ||
        FileNameObj === "xltx"
      ) {
        const formData = new FormData();
        formData.append("body", filetemp);
        fetch(Config.apiUrl + "ArticleProduct/Import", {
          method: "POST",
          headers: {
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: formData,
        }).then((result) => {
          result.json().then((resp) => {
            getData();
            if (resp != null) {
              swal("Import", "Article's  is Import.", "success");
            } else {
              swal("Sorry!", "Article's  is not Import.", "error");
            }
          });
        });
      } else {
        swal("Sorry", "please sample file download and check file", "warning");
      }
    }
  };
  const columnsVariant = React.useMemo(
    () => [
      {
        name: "Sr. No",
        width: "7%",
        accessor: "variantsrnumber",
        selector: (row) => `${row.variantsrnumber}`,
        sortable: false,
        cell: (row, index) => row.sr,
      },
      {
        name: "Image",
        accessor: "productimage",
        selector: "productimage",
        sortable: false,
        cell: (row) => {
          {
            let FullPath = `${Config.contentUrl + row.attributeImagePath}`;
            return row.attributeImagePath !== null && row.attributeImagePath !== undefined &&
              row.attributeImagePath != "" ? (
              <img
                src={FullPath}
                className="table-main-image btn-shadow"
                // onError={({ currentTarget }) => {
                //   currentTarget.onerror = null;
                //   currentTarget.src = "../assets/img/new-images/images.png";
                // }}
              ></img>
            ) : (
              <img
                src="../assets/img/new-images/images.png"
                style={{ height: "50px", width: "50px " }}
              ></img>
            );
          }
        },
      },
      {
        name: "Atribute",
        accessor: "attributeValue1",
        selector: (row) => `${row.attributeValue1}`,
        sortable: false,
        headerClassName: "rt-tr-align-right",
        cell: (row, index) => {
          if (
            row.attributeValue1 !== "" &&
            row.attributeValue2 !== "" &&
            row.attributeValue3 !== "" &&
            row.attributeValue4 !== "" &&
            row.attributeValue5 !== ""
          ) {
            return (
              <span>
                {row.attributeValue1 +
                  "/" +
                  row.attributeValue2 +
                  "/" +
                  row.attributeValue3 +
                  "/" +
                  row.attributeValue4 +
                  "/" +
                  row.attributeValue5}
              </span>
            );
          } else if (
            row.attributeValue1 !== "" &&
            row.attributeValue2 !== "" &&
            row.attributeValue3 !== "" &&
            row.attributeValue4 !== "" &&
            row.attributeValue5 === ""
          ) {
            return (
              <span>
                {row.attributeValue1 +
                  "/" +
                  row.attributeValue2 +
                  "/" +
                  row.attributeValue3 +
                  "/" +
                  row.attributeValue4}
              </span>
            );
          } else if (
            row.attributeValue1 !== "" &&
            row.attributeValue2 !== "" &&
            row.attributeValue3 !== "" &&
            row.attributeValue4 === "" &&
            row.attributeValue5 === ""
          ) {
            return (
              <span>
                {row.attributeValue1 +
                  "/" +
                  row.attributeValue2 +
                  "/" +
                  row.attributeValue3}
              </span>
            );
          } else if (
            row.attributeValue1 !== "" &&
            row.attributeValue2 !== "" &&
            row.attributeValue3 === "" &&
            row.attributeValue4 === "" &&
            row.attributeValue5 === ""
          ) {
            return (
              <span>{row.attributeValue1 + "/" + row.attributeValue2}</span>
            );
          } else if (
            row.attributeValue1 !== "" &&
            row.attributeValue2 === "" &&
            row.attributeValue3 === "" &&
            row.attributeValue4 === "" &&
            row.attributeValue5 === ""
          ) {
            return <span>{row.attributeValue1}</span>;
          } else {
            return <span>N / A</span>;
          }
        },
      },
      {
        name: "QR Code",
        accessor: "articleQrcode",
        selector: (row) => `${row.articleQrcode}`,
        sortable: false,
        cell: (row) => {
          return row.qrCode !== null &&
            row.qrCode !== "" &&
            row.qrCode !== undefined ? (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border " +
                  (row.isPublished === false ? "border-danger" : "")
                }
                onClick={() => {
                  toggleArticleVariant(row);
                }}
              >
                <img
                  src="../assets/img/user/QR.png"
                  alt="img"
                  style={{ height: "40px", width: "40px" }}
                  // onerror="this.src='../assets/img/new-images/images.png';"
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>{row.isPublished === false ? "Pause" : "Play"}</b>
              </p>
            </div>
          ) : row.isshow == true ? (
            <div>
              <button
                className={
                  "m-t-5 btn btn-white btn-shadow p-2 border " +
                  (row.isPublished === false ? "border-danger" : "")
                }
                onClick={(e) => {
                  toggleQrCodeModal(row);
                }}
              >
                <img
                  src="../assets/img/new-Images/qr-code-scanner.jpg"
                  style={{ height: "40px", width: "40px" }}
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>{row.isPublished === false ? "Pause" : "Play"}</b>
              </p>
            </div>
          ) : (
            <div>
              <button
                className="m-t-5 btn btn-white btn-shadow p-2 border"
                onClick={(e) => {
                  swal("  Oops... not allowed ! ");
                }}
              >
                <img
                  src="../assets/img/new-Images/qr-code-scanner.jpg"
                  style={{ height: "30px", width: "30px" }}
                ></img>
              </button>
              <p className="small text-center m-t-5">
                <b>{row.isPublished === false ? "Pause" : "Play"}</b>
              </p>
            </div>
          );
        },
      },
      {
        name: "Total Scans",
        accessor: "totalScans",
        selector: (row) => `${row.totalScans}`,
        sortable: true,
        headerClassName: "rt-tr-align-right",
        cell: (row) => {
          {
            return row.totalScans !== null && row.totalScans !== "" ? (
              <div className="">
                <p className="m-0 text-center">{row.totalScans}</p>
              </div>
            ) : (
              <div className="">
                <p className="m-0">0</p>
              </div>
            );
          }
        },
      },
      {
        name: " Created Date",
        accessor: "createdDate",
        selector: (row) => `${row.createdDate}`,
        sortable: true,
        cell: (row) => {
          let date = new Date(row.createdDate);
          let dateMDY = `${date.getDate()}-${date.getMonth() + 1
            }-${date.getFullYear()}`;
          return <span>{dateMDY}</span>;
        },
      },
      {
        name: " Actions",
        accessor: "col13",
        sortable: false,
        cell: (row) => {
          return (
            <div>
              {row.isshow == true ? (
                <UncontrolledButtonDropdown>
                  <DropdownToggle className="btn btn-success btn btn-warning ellipsis-btn">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </DropdownToggle>
                  {row?.qrCode !== null && row?.qrCode !== "" ? (
                    <DropdownMenu>
                      <DropdownItem
                        onClick={(e) => {
                          row?.isPublished === false
                            ? VariantPlay(row)
                            : VariantPlayAllready();
                        }}
                      >
                        <i className="fas fa-play m-r-10"></i>
                        Play
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          row?.isPublished === false
                            ? VariantAllreadypush()
                            : VariantPause(row);
                        }}
                      >
                        <i className="fas fa-pause m-r-10"></i>
                        Pause
                      </DropdownItem>
                    </DropdownMenu>
                  ) : (
                    <DropdownMenu>
                      <DropdownItem
                        onClick={(e) => {
                          swal("Oops... Your Qrcode Not Generate ! ");
                        }}
                      >
                        <i className="fas fa-play m-r-10"></i>
                        Play
                      </DropdownItem>
                      <DropdownItem divider></DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          swal("Oops... Your Qrcode Not Generate ! ");
                        }}
                      >
                        <i className="fas fa-pause m-r-10"></i>
                        Pause
                      </DropdownItem>
                    </DropdownMenu>
                  )}
                </UncontrolledButtonDropdown>
              ) : (
                <UncontrolledButtonDropdown>
                  <DropdownToggle className="btn btn-success btn btn-warning ellipsis-btn">
                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={(e) => {
                        swal("  Oops... not allowed ! ");
                      }}
                    >
                      <i className="fas fa-play m-r-10"></i>
                      Play
                    </DropdownItem>
                    <DropdownItem divider></DropdownItem>
                    <DropdownItem
                      onClick={(e) => {
                        swal("  Oops... not allowed ! ");
                      }}
                    >
                      <i className="fas fa-pause m-r-10"></i>
                      Pause
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledButtonDropdown>
              )}
            </div>
          );
        },
      },
    ],
    []
  );
  const getDataArticleVariation = (ArticleProductID) => {
    let loginid = localStorage.getItem("loginUserID");
    // setTotalCount(0);
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      ArticleProductID !== "" &&
      ArticleProductID !== undefined &&
      ArticleProductID !== null
    ) {
      fetch(
        Config.apiUrl +
        "ArticleProduct/GetArticleAllvariation?id=" +
        ArticleProductID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          console.log("resulyjhfd=>", result);
          if (result !== null) {
            setArticlesNo(result?.articleNumber);
            setArticlesName(result?.articleName);
            if (
              result?.categorydetail != null &&
              result?.categorydetail != ""
            ) {
              setArticlescategoryName(result?.categorydetail?.name);
              setArticlessubcategoryName(result?.subcategorydetail?.name);
            }
            //setTotalCount(result?.totalCount);
            setArticlesVariationList(result?.attributeValueMappingList);
            if(result?.productImage !== null && result?.productImage !=="" && result?.productImage !== undefined ){
              let FullPath = `${Config.contentUrl + result?.productImage}`;
              setArticlesProfileImage(FullPath);
            }
            else{
              setArticlesProfileImage("")
            }
            setvariationlistmodal(true);
          } else {
            setArticlesVariationList([]);
          }
        });
      });
    }
  };
  const handleChange = (state) => {
    setSelectedData(state.selectedRows);
  };
  const ProductVariations = (ArticleProductID) => {
    if (
      ArticleProductID != null &&
      ArticleProductID != "" &&
      ArticleProductID != undefined
    ) {
      if (variationlistmodal === false) {
        getDataArticleVariation(ArticleProductID);
      } else {
        setvariationlistmodal(false);
        setArticlesNo("");
        setArticlesName("");
        setArticlescategoryName("");
        setArticlessubcategoryName("");
        setArticlesVariationList([]);
        setArticlesProfileImage("");
      }
      // setvariationlistmodal(false);
    } else {
      setvariationlistmodal(false);
      setArticlesNo("");
      setArticlesName("");
      setArticlescategoryName("");
      setArticlessubcategoryName("");
      setArticlesVariationList([]);
      setArticlesProfileImage("");
    }
  };
  const Exportvariations = () => {
    let loginid = localStorage.getItem("loginUserID");
    let TotalIteam = [];
    let Auth0token = localStorage.getItem("Auth0token");
    for (let index = 0; index < selectedData.length; index++) {
      TotalIteam.push(selectedData[index]._id);
    }
    if (TotalIteam.length > 0) {
      fetch(Config.apiUrl + "AttributeValueMap/Export", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(TotalIteam),
      })
        .then((response) => response.blob())
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = "ExportVariation.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    } else {
      swal("Sorry!", "pleace select variation.", "error");
    }
  };
  const GoToProductinformationPage = (ProductID) => {
    history.push({
      pathname: "/article-infopage",
      state: { ProductID: ProductID },
    });
  };
  const QRCodeArticleSend = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail.length !== unique.length) {
      setisToemailMaltiple(true);
      return;
    }
    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      // "To": "rprajapati@eagletechsolutions.uk",
      subject: "Qrcode",
      body: QrcodeProductname,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(
      Config.apiUrl +
      "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        console.log("123=====>", resp1);
        if (resp1 === true) {
          toggleToEmail();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };
  const QRCodeArticleSendAttributecreate = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail.length !== unique.length) {
      setisToemailMaltiple(true);
      return;
    }

    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById("qrCodeEl1")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    // let Toemail = [];
    // Toemail.push("rprajapati@eagletechsolutions.uk")

    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      // "To": "rprajapati@eagletechsolutions.uk",
      subject: "Qrcode",
      body: selectCombination,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        console.log("123=====>", resp1);
        if (resp1 === true) {
          toggleToEmailAttributecreate();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };

  const downloadQRCodeArticle = () => {
    // const qrCodeURL = document.getElementById('qrCodeEl')
    //     .toDataURL("image/png")
    //     .replace("image/png", "image/octet-stream");
    // var doc = new jsPDF("p", "pt", "c6");
    // doc.setFontSize(22);
    // doc.text(20, 30, "Qr Code");
    // doc.setFontSize(10);
    // // doc.text(20, 80, "Title: " + row.title);
    // // doc.text(20, 100, "Years: " + row.years);
    // doc.addImage(qrCodeURL, "JPEG", 100, 100, 150, 200);
    // doc.save("QrCode.pdf");
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log("qrCodeURL", qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  const printQrcode = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    doc.setFontSize(22);
    doc.text(20, 30, QrcodeProductname);
    doc.setFontSize(10);
    // doc.text(20, 80, "Title: " + row.title);
    // doc.text(20, 100, "Years: " + row.years);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 200, 200);
    //doc.save("QrCode.pdf");
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };
  const printQrcodeAttributecreate = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl1")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    doc.setFontSize(22);
    doc.text(20, 30, QrcodeProductname);
    doc.setFontSize(10);
    // doc.text(20, 80, "Title: " + row.title);
    // doc.text(20, 100, "Years: " + row.years);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 200, 200);
    //doc.save("QrCode.pdf");
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };
  const VariantPlayAllready = () => {
    swal("Your Variant already Play !");
  };
  const VariantAllreadypush = () => {
    swal("Your Variant already push !");
  };
  const VariantPlay = (item) => {
    let seleteVariantID = item?._id;
    let articleID = item?.articleID;
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteVariantID != null &&
      seleteVariantID != "" &&
      seleteVariantID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "AttributeValueMap/UpdateIsPublish?id=" +
        seleteVariantID +
        "&isPublish=" +
        true,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            getDataArticleVariation(articleID);
            swal("Congratulations! Your Article is Play successfully.", {
              icon: "success",
            });
          } else {
            swal("Your Article  Your Article not Play successfully.!");
          }
        });
      });
    }
  };
  const VariantPause = (item) => {
    let loginid = localStorage.getItem("loginUserID");
    let seleteVariantID = item?._id;
    let articleID = item?.articleID;
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      seleteVariantID != null &&
      seleteVariantID != "" &&
      seleteVariantID != undefined
    ) {
      fetch(
        Config.apiUrl +
        "AttributeValueMap/UpdateIsPublish?id=" +
        seleteVariantID +
        "&isPublish=" +
        false,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            getDataArticleVariation(articleID);
            swal("Congratulations! Your Article is Pause successfully.", {
              icon: "success",
            });
          } else {
            swal("Your Article  Your Article not Pause successfully.!");
          }
        });
      });
    }
  };
  const toggleQrCodeModal = (row) => {
    if (
      row?.articleID !== null &&
      row?.articleID !== undefined &&
      row?.articleID !== ""
    ) {
      setArticleId(row?.articleID);
      setQrCodeString("");
      setQrCodeModalisOpen(!QrCodeModalisOpen);
      setselectCombinationID(row?._id);
      if (
        row?.attributeValue1 !== "" &&
        row?.attributeValue2 !== "" &&
        row?.attributeValue3 !== "" &&
        row?.attributeValue4 !== "" &&
        row?.attributeValue5 !== ""
      ) {
        setselectCombination(
          row?.attributeValue1 +
          "/" +
          row?.attributeValue2 +
          "/" +
          row?.attributeValue3 +
          "/" +
          row?.attributeValue4 +
          "/" +
          row?.attributeValue5
        );
      } else if (
        row?.attributeValue1 !== "" &&
        row?.attributeValue2 !== "" &&
        row?.attributeValue3 !== "" &&
        row?.attributeValue4 !== "" &&
        row?.attributeValue5 === ""
      ) {
        setselectCombination(
          row?.attributeValue1 +
          "/" +
          row?.attributeValue2 +
          "/" +
          row?.attributeValue3 +
          "/" +
          row?.attributeValue4
        );
      } else if (
        row?.attributeValue1 !== "" &&
        row?.attributeValue2 !== "" &&
        row?.attributeValue3 !== "" &&
        row.attributeValue4 === "" &&
        row.attributeValue5 === ""
      ) {
        setselectCombination(
          row?.attributeValue1 +
          "/" +
          row?.attributeValue2 +
          "/" +
          row?.attributeValue3
        );
      } else if (
        row?.attributeValue1 !== "" &&
        row?.attributeValue2 !== "" &&
        row?.attributeValue3 === "" &&
        row?.attributeValue4 === "" &&
        row?.attributeValue5 === ""
      ) {
        setselectCombination(row?.attributeValue1 + "/" + row?.attributeValue2);
      } else if (
        row?.attributeValue1 !== "" &&
        row?.attributeValue2 === "" &&
        row?.attributeValue3 === "" &&
        row?.attributeValue4 === "" &&
        row?.attributeValue5 === ""
      ) {
        setselectCombination(row?.attributeValue1);
      } else {
        setselectCombination("N/A");
      }
    } else {
      setQrCodeModalisOpen(false);
      setQrCodeString("");
    }
  };

  const Qrcodegenerator = async (e) => {
    if (
      selectCombinationID != "" &&
      selectCombinationID != undefined &&
      selectCombinationID != null
    ) {
      console.log("button clicked");
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      // let url =
      //   Config.FrontUrl +
      //   "productdetails?mapId=" +
      //   selectCombinationID +
      //   "&render=Combination&maptarget=article";
      let ArticleQrcodestring = {
        UserCompanyID: loginid,
        TargetType: "ArticleQrCodeAttributes",
        TargetID: selectCombinationID,
        // CodeString: url,
        CodeString: "",
        IsDeleted: false,
        BatchNumber: "",
        EnableEWarranty: false,
        Expirydate: null,
        Manufacturedate: null,
        Manufacturedatestring: null,
        VendorId: "",
      };
      fetch(Config.apiUrl + "QrCodeResourceController/CreateQrcodestring", {
        headers: {
          userCompanyID: loginid,
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
        method: "POST",
        body: JSON.stringify(ArticleQrcodestring),
      })
        .then((result) => {
          result.json().then((resp) => {
            if (resp !== null) {
              // getData();
              getqrcodeAttributes(selectCombinationID);

              swal("successfully", "Article  Qrcode generate.", "success");
            } else {
              swal("error", "Article  Qrcode not generate.", "error");
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const getqrcodeAttributes = (CombinationID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      CombinationID !== null &&
      CombinationID !== "" &&
      CombinationID !== undefined
    ) {
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/GetQrcodestring?targetId=" +
        CombinationID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          //Do something with the response
          console.log("responseJson=>", responseJson);
          if (responseJson !== null && responseJson !== "") {
            let qrcodestring = domainFrontUrl.current + responseJson.codeString;
            setQrCodeString(qrcodestring);
            // setQrCodeString(responseJson.codeString);
            getDataArticleVariation(ArticleId);
          } else {
            setQrCodeString("");
          }
        })
        .catch((error) => {
          console.log(error);
          setQrCodeString("");
        });
    } else {
      setQrCodeString("");
    }
    //
  };
  // const printQrcode = () => {
  //     const qrCodeURL = document.getElementById('qrCodeEl')
  //         .toDataURL("image/png")
  //         .replace("image/png", "image/octet-stream");
  //     var doc = new jsPDF("p", "pt", "A4");
  //     //var doc = new jsPDF('p','mm',[297, 210]);
  //     doc.setFontSize(22);
  //     doc.text(20, 30, ArticleName);
  //     doc.setFontSize(10);
  //     // doc.text(20, 80, "Title: " + row.title);
  //     // doc.text(20, 100, "Years: " + row.years);
  //     doc.addImage(qrCodeURL, "JPEG", 100, 100, 100, 100);
  //     //doc.save("QrCode.pdf");
  //     doc.autoPrint();
  //     doc.output('dataurlnewwindow');
  // }
  const downloadQRCodeAttributecreate = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl1")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    console.log(qrCodeURL);
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };
  const QrcodeCombinationalredycreate = () => {
    swal("Combination QR code, has been already generated");
  };
  const SubToEmailremoveClick = (i) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToEmailTemp = [...subToEmail];
    if (subToEmailTemp != null && subToEmailTemp !== undefined) {
      subToEmailTemp.splice(i, 1);
    }
    setsubToEmail(subToEmailTemp);
  };
  const SubToEmailhandleChange = (i) => (event) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToemaillistnewTemp = [...subToEmail];
    subToemaillistnewTemp[i] = event.target.value;
    setsubToEmail(subToemaillistnewTemp);
    const unique = [...new Set(subToemaillistnewTemp)];
    if (subToemaillistnewTemp.length !== unique.length) {
      setisToemailMaltiple(true);
    }
  };
  const SubToEmailaddClick = () => {
    setsubToEmail((n) => [...n, ""]);
  };

  const createSubToEmailUI = () => {
    return subToEmail.map((el, i) => (
      <div key={i} className="removeSection">
        <input
          type="text"
          className="form-control mr-2"
          //maxlength="50"
          placeholder="Enter To Email "
          value={el || ""}
          onChange={SubToEmailhandleChange(i)}
        />
        {i > 0 ? (
          <a
            href="javascript:void(0)"
            onClick={(e) => {
              SubToEmailremoveClick(i);
            }}
            className="btn btn-danger"
          >
            <i class="fas fa-trash"></i>
          </a>
        ) : (
          <></>
        )}
      </div>
    ));
  };

  const OnIscertificatesClick = () => {
    setiscertificatesopen(!iscertificatesopen);
  }

  const onClickCollapse = (id) => {
    if (id != null && id != "" && id != undefined) {
      let Collapseidlistold = [...Collapseidlist];
      if (Collapseidlistold.length > 0) {
        let olddata = Collapseidlistold.filter((e) => e.includes(id));
        if (olddata != null && olddata != "" && olddata != undefined) {
          Collapseidlistold.pop(olddata);
        }
        else {
          Collapseidlistold.push(id);
        }
      }
      else {
        Collapseidlistold.push(id);
      }
      setCollapseidlist(Collapseidlistold);
    }
  }
  const togglepreviewModal = (_id) => {
    if (_id != null && _id != "" && _id != undefined) {
      GetAllProductInfo(_id)
    }
    else {
      setPreviewModalisOpen(false);
    }
  };

  const handleTitleFontChange = (event) => {
    const colorValue = event.target.value + 'px';
    settitlefontsize(event.target.value);
    settitlefontsizeFinal(colorValue);
  };
  const handleDescriptionFontChange = (event) => {
    const colorValue = event.target.value + 'px';
    setdescriptionfontsize(event.target.value);
    setdescriptionfontsizeFinal(colorValue);
  };
  const handleColor2 = (event) => {
    const colorValue = event.target.value;
    setColor2("#" + colorValue);
  };
  const handleColor3 = (event) => {
    const colorValue = event.target.value;
    setColor3("#" + colorValue);
  };
  const handleColor1 = (event) => {
    const colorValue = event.target.value;
    setColor1("#" + colorValue);
  };



  const handleOptionChange = (event) => {
    setIsBackgroundUrl(true);
    setuploadBackgroundImage(null);
    setColor2("");


  };
  const handleOptionChangecolor = (event) => {
    setIsBackgroundUrl(false);
    setuploadBackgroundImage(null);
    setpageBackgroundImage("");
    setColor2("#01F9C6");
  };

  const handleckTitleFontChange = (event) => {
    const fontSizeValue = event.target.value + 'px';
    setCkeditorTitleFontSize(event.target.value);
    setCkeditorTitleFontSizeFinal(fontSizeValue)

  };
  const handlelogoshadowChange = (event) => {
    const fontSizeValue = event.target.value + 'px';
    setlogoshadow(event.target.value);
    setlogoshadowFinal(fontSizeValue)

  };




  const selectdefaultTheme = (e) => {
    const id = e.target.value;
    if (id != null && id != "" && id != undefined) {
      setDefaultThemeId(id);
      let defaultThemelistold = [...defaultThemelistTemp];
      if (defaultThemelistold != null && defaultThemelistold != undefined && defaultThemelistold != "" && defaultThemelistold.length > 0) {
        let selectitem = defaultThemelistold.find(x => x._id == id);
        if (selectitem != null && selectitem != "" && selectitem != undefined) {
          setuploadBackgroundImage(null);
          setColor1(selectitem?.color1);
          setColor2(selectitem?.color2);
          setColor3(selectitem?.color3);
          setIsBackgroundUrl(selectitem?.isBackgroundUrl);

          if (selectitem?.titleFontSize !== null && selectitem?.titleFontSize !== "" && selectitem?.titleFontSize !== undefined) {
            let titlefontsizeold = selectitem?.titleFontSize.split('px');
            settitlefontsize(parseInt(titlefontsizeold[0]));
            settitlefontsizeFinal(selectitem?.titleFontSize);
          }
          else {
            settitlefontsize(16);
            settitlefontsizeFinal("16px")
          }

          if (selectitem?.descriptionFontSize !== null && selectitem?.descriptionFontSize !== "" && selectitem?.descriptionFontSize !== undefined) {
            let titlefontsizeold = selectitem?.descriptionFontSize.split('px');
            setdescriptionfontsize(parseInt(titlefontsizeold[0]));
            setdescriptionfontsizeFinal(selectitem?.descriptionFontSize)
          }
          else {
            setdescriptionfontsize(16);
            setdescriptionfontsizeFinal("16px")
          }

          if (selectitem?.dropDownDetailTitleFontSize !== null && selectitem?.dropDownDetailTitleFontSize !== "" && selectitem?.dropDownDetailTitleFontSize !== undefined) {
            let titlefontsizeold = selectitem?.dropDownDetailTitleFontSize.split('px');
            setCkeditorTitleFontSize(parseInt(titlefontsizeold[0]));
            setCkeditorTitleFontSizeFinal(selectitem?.dropDownDetailTitleFontSize)
          }
          else {
            setCkeditorTitleFontSize(16);
            setCkeditorTitleFontSizeFinal("16px")
          }

          if (selectitem?.dropDownDetailDisciptionFontSize !== null && selectitem?.dropDownDetailDisciptionFontSize !== "" && selectitem?.dropDownDetailDisciptionFontSize !== undefined) {
            let titlefontsizeold = selectitem?.dropDownDetailDisciptionFontSize.split('px');
            setCkeditorDescriptionFontSize(parseInt(titlefontsizeold[0]));
            setCkeditorDescriptionFontSizeFinal(selectitem?.dropDownDetailDisciptionFontSize)
          }
          else {
            setCkeditorDescriptionFontSize(16);
            setCkeditorDescriptionFontSizeFinal("16px")
          }
        }
      }
    }
    else {
      setDefaultThemeId("");
    }

  }

  const clereproducttheme = () => {
    setDefaultThemeId("");
    setuploadBackgroundImage(null);
    settitlefontsize(16);
    settitlefontsizeFinal("16px");
    setdescriptionfontsize(16);
    setdescriptionfontsizeFinal("16px");
    setCkeditorTitleFontSize(16);
    setCkeditorTitleFontSizeFinal("16px")
    setCkeditorDescriptionFontSize(16);
    setCkeditorDescriptionFontSizeFinal("16px");
    setIsBackgroundUrl(false);
    setpageBackgroundImage("");
    setColor1("#0a0303");
    setColor2("#01F9C6")
    setColor3("#617C58")
  }

  const getProductQrcodeTheme = (articleidObj) => {
    fetch(Config.apiUrl + "productQrcodeTheme/GetProductQrcodeThemeByArticleProductId?ArticleProductId=" + articleidObj, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        if (resp1 !== null) {
          setProductQrcodeThemeId(resp1?._id ? resp1?._id : "");
          setDefaultThemeId(resp1?.defaultThemeId ? resp1?.defaultThemeId : "");

          if (resp1?.titleFontSize !== null && resp1?.titleFontSize !== "" && resp1?.titleFontSize !== undefined) {
            let titlefontsizeold = resp1?.titleFontSize.split('px');
            settitlefontsize(titlefontsizeold[0]);
            settitlefontsizeFinal(resp1?.titleFontSize)
          }
          else {
            settitlefontsize(16);
            settitlefontsizeFinal("16px")
          }

          if (resp1?.descriptionFontSize !== null && resp1?.descriptionFontSize !== "" && resp1?.descriptionFontSize !== undefined) {
            let titlefontsizeold = resp1?.descriptionFontSize.split('px');
            setdescriptionfontsize(titlefontsizeold[0]);
            setdescriptionfontsizeFinal(resp1?.descriptionFontSize)
          }
          else {
            setdescriptionfontsize(16);
            setdescriptionfontsizeFinal("16px")
          }

          if (resp1?.dropDownDetailTitleFontSize !== null && resp1?.dropDownDetailTitleFontSize !== "" && resp1?.dropDownDetailTitleFontSize !== undefined) {
            let titlefontsizeold = resp1?.dropDownDetailTitleFontSize.split('px');
            setCkeditorTitleFontSize(titlefontsizeold[0]);
            setCkeditorTitleFontSizeFinal(resp1?.dropDownDetailTitleFontSize)
          }
          else {
            setCkeditorTitleFontSize(16);
            setCkeditorTitleFontSizeFinal("16px")
          }

          if (resp1?.dropDownDetailDisciptionFontSize !== null && resp1?.dropDownDetailDisciptionFontSize !== "" && resp1?.dropDownDetailDisciptionFontSize !== undefined) {
            let titlefontsizeold = resp1?.dropDownDetailDisciptionFontSize.split('px');
            setCkeditorDescriptionFontSize(titlefontsizeold[0]);
            setCkeditorDescriptionFontSizeFinal(resp1?.dropDownDetailDisciptionFontSize)
          }
          else {
            setCkeditorDescriptionFontSize(16);
            setCkeditorDescriptionFontSizeFinal("16px")
          }
          setuploadBackgroundImage(null);
          if (resp1?.isBackgroundUrl == true) {
            setColor2(resp1?.color2 ? resp1?.color2 : "");
            setIsBackgroundUrl(resp1?.isBackgroundUrl);
          }
          else {
            setColor2(resp1?.color2 ? resp1?.color2 : "#01F9C6");
            setIsBackgroundUrl(resp1?.isBackgroundUrl);
          }
          setColor1(resp1?.color1 ? resp1?.color1 : "#0a0303");
          setColor3(resp1?.color3 ? resp1?.color3 : "#FFFFFF");
        }
      });

  }

  const GetAllProductInfo = (articleidObj) => {
    setisLoading(true);
    if (
      articleidObj != null &&
      articleidObj != "" &&
      articleidObj != undefined
    ) {
      setisLoading(true);
      getProductQrcodeTheme(articleidObj);
      fetch(
        Config.apiUrl +
        "ArticleProduct/GetArticleAllInformationWithOutUserCompanyId?id=" +
        articleidObj,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result._id != null) {
            setproductinfo(result);
            setPreviewModalisOpen(true);
          }
          else {
            setproductinfo(null);
          }
          setTimeout(() => {
            setisLoading(false);
          }, 3000);
        });
      });
    }
  };

  const GetalldefaultTheme = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    fetch(Config.apiUrl + "defaultTheme/GetAllDefaultQrcodeTheme", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        if (resp1 !== null && resp1?.length > 0) {
          setDefaultThemelistTemp(resp1);
          const DefaultThemelisttemp = [];
          const temp = { label: "--- select Theme -- ", value: "" };
          DefaultThemelisttemp.push(temp);
          if (resp1 !== null && resp1 !== undefined && resp1 !== "") {
            for (let index = 0; index < resp1.length; index++) {
              const element = resp1[index];
              if (element != null && element != undefined) {
                const data = {
                  label: element?.themeName ? element?.themeName : "N/A",
                  value: element?._id
                }
                DefaultThemelisttemp.push(data);
              }
            }
          }
          setDefaultThemelist(DefaultThemelisttemp);
        } else {
          const temp = { label: "--- select Theme -- ", value: "*" };
          setDefaultThemelist(temp);
          setDefaultThemelistTemp([]);
        }
      });
  }

  const uploadBackgroundImageFile = (e) => {
    setuploadBackgroundImage(e.target.files[0]);
    setColor2(URL.createObjectURL(e.target.files[0]))
  }

  const addupdateProductQrcodeTheme = () => {
    setisbuttonLoading(true);
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    if (uploadBackgroundImage != null && uploadBackgroundImage != "" && uploadBackgroundImage != undefined) {
      const formData = new FormData();
      formData.append("body", uploadBackgroundImage);

      fetch(Config.apiUrl + "FileUpload/createBackgroundImage", {
        headers: {
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        method: "POST",
        body: formData,
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null && resp?.responseType == "Success") {
            const bodys = {
              "_id": productQrcodeThemeId,
              "articleProductId": productinfo?._id,
              "defaultThemeId": defaultThemeId,
              "isBackgroundUrl": IsBackgroundUrl,
              "Color1": Color1,
              "Color2": resp?.responseUrl,
              "Color3": Color3,
              "TitleFontSize": titlefontsizeFinal,
              "DescriptionFontSize": descriptionfontsizeFinal,
              "DropDownDetailTitleFontSize": ckeditorDescriptionFontSizeFinal,
              "DropDownDetailDisciptionFontSize": ckeditorTitleFontSizeFinal,
              "Sliderimground": "",
              "logoshadow": logoshadowFinal
            };
            fetch(
              Config.apiUrl +
              "productQrcodeTheme/CreateOrUpdateProductQrcodeTheme", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(bodys),
            })
              .then((response) => {
                if (response.ok) {
                  return response.json();
                }
                throw new Error("Something went wrong");
              })
              .then((resp1) => {
                setisbuttonLoading(false);
                if (resp1 === true) {
                  // clereproducttheme();
                  // setPreviewModalisOpen(false);
                  setissuccess(true);
                  setiserror(false);
                  setTimeout(function () {
                    setissuccess(false)
                  }, 5000);
                  //swal("Thank You", "Your details are saved.", "success");
                } else {
                  //swal("Sorry", "Your details are not saved", "error");
                  setissuccess(false);
                  setiserror(true);
                  setTimeout(function () {
                    setiserror(false)
                  }, 5000);
                }
              });
          }
          else {
            setisbuttonLoading(false);
            setissuccess(false);
            setiserror(true);
            setTimeout(function () {
              setiserror(false)
            }, 5000);
            //swal("Sorry", "Your details are not saved", "error");
          }
        });
      });

    }
    else {
      const bodys = {
        "_id": productQrcodeThemeId,
        "articleProductId": productinfo?._id,
        "defaultThemeId": defaultThemeId,
        "isBackgroundUrl": IsBackgroundUrl,
        "Color1": Color1,
        "Color2": Color2,
        "Color3": Color3,
        "TitleFontSize": titlefontsizeFinal,
        "DescriptionFontSize": descriptionfontsizeFinal,
        "DropDownDetailTitleFontSize": ckeditorDescriptionFontSizeFinal,
        "DropDownDetailDisciptionFontSize": ckeditorTitleFontSizeFinal,
        "Sliderimground": "",
        "logoshadow": logoshadowFinal
      };
      fetch(
        Config.apiUrl +
        "productQrcodeTheme/CreateOrUpdateProductQrcodeTheme", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(bodys),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          setisbuttonLoading(false);
          if (resp1 === true) {
            // clereproducttheme();
            // setPreviewModalisOpen(false);
            setissuccess(true);
            setiserror(false);
            setTimeout(function () {
              setissuccess(false)
            }, 5000);
            //swal("Thank You", "Your details are saved.", "success");
          } else {
            //swal("Sorry", "Your details are not saved", "error");
            setissuccess(false);
            setiserror(true);
            setTimeout(function () {
              setiserror(false)
            }, 5000);
          }
        });
    }

  }

  return (
    <>
      <div>
        <LoaderSpinner isrefresh={Isloading} />
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <a href="/home">Home</a>
          </li>
          <li className="breadcrumb-item active"> Article QR Code</li>
        </ol>
        {/* <h1 className="page-header">Loved QR Code</h1> */}
        <div className="mb-2">
          <div className="row justify-content-end">
            <button
              className="btns btn btn-primary search-btn  mr-2 mb-1"
              onClick={(e) => {
                AddArticleDetails("");
              }}
            >
              <i class="fas fa-lg fa-fw m-r-5 fa-plus-square icon"></i>
              Add new
            </button>
            <button
              type="button"
              className="btns btn  btn-danger  mr-2 mb-1"
              onClick={onSelcetdArticleDelete}
            >
              <i className="far fa-lg fa-fw m-r-5 fa-trash-alt icon"></i>
              Delete (selected)
            </button>
          </div>
        </div>
        {/* <Panel>
          <PanelHeader>
            <div>
              <h4 className="mb-0 text-light">
                <i className="fas fa-fw m-r-10 fa-search"></i> Search
              </h4>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="row mt-2">
              <div className="col-xl-6 px-4">
                <form action="javascript:void(0);" method="POST">
                  <fieldset>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Article name{" "}
                      </label>
                      <div className="col-md-7">
                        <input
                          type="text"
                          className="form-control input-height"
                          placeholder="Enter Article name"
                          value={ArticleName}
                          onChange={onChangeArticleName}
                        />
                      </div>
                    </div>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Category{" "}
                      </label>
                      <div className="col-md-7">
                        <select
                          className="default-select2 form-control"
                          value={CategoryId}
                          onChange={onChangeCategory}
                        >
                          <option value="" selected>
                            --- Select Category ---
                          </option>
                          {CategoryList.map((item, i) => (
                            <option value={item._id}>{item.name}</option>
                          ))}
                        </select>
                        {CategoryError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {CategoryError}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="form-group row m-b-10 d-flex align-items-center">
                      <label className="col-md-4 col-xs-9 col-form-label product-lable">
                        Search sub Category
                      </label>
                      <div className="col-md-7 col-xs-3">
                        <div className="form-check">
                          <input
                            className="form-check-input checkbox-label"
                            type="checkbox"
                            checked={issubcategoryshow}
                            onChange={handleChangeCategory}
                            id="defaultCheckbox"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="defaultCheckbox"
                          ></label>
                        </div>
                      </div>
                    </div>

                    {issubcategoryshow === true ? (
                      <div className="form-group row m-b-15 d-flex align-items-center">
                        <label className="col-md-4 col-form-label product-lable">
                          sub Category{" "}
                        </label>
                        <div className="d-none d-md-block d-lg-block">:</div>
                        <div className="col-md-7">
                          <select
                            class="default-select2 form-control"
                            value={subcategoryId}
                            onChange={onChangeSubCategory}
                          >
                            <option value="" selected>
                              --- Select Category ---
                            </option>
                            {subcetgoryList.map((item) => (
                              <option value={item._id}>{item.name}</option>
                            ))}
                            {subcategoryIdError.length > 0 && (
                              <span style={{ color: "red", marginLeft: 6 }}>
                                {subcategoryIdError}
                              </span>
                            )}
                          </select>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label  product-lable">
                        Label{" "}
                      </label>
                      <div className="col-md-7">
                        <select
                          className="default-select2  form-control"
                          value={LabelId}
                          onChange={onChangeLabeldrop}
                        >
                          <option value="" selected>
                            --- Select Label ---
                          </option>
                          {LabelList.map((item, i) => (
                            <option key={i} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                        {LabelError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {this.state.LabelError}
                          </span>
                        )}
                      </div>
                    </div>

                  </fieldset>
                </form>
              </div>
              <div className="col-xl-6 px-4">
                <form action="javascript:void(0);" method="POST">
                  <fieldset>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Article type{" "}
                      </label>
                      <div className="col-md-7">
                        <select
                          className="default-select2  form-control"
                          value={ArticlesTypeId}
                          onChange={onChangeArticledroptype}
                        >
                          <option value="" selected>
                            --- Select Article Type ---
                          </option>
                          {ArticlesTypeList.map((item, i) => (
                            <option key={i} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                        {ArticleTypeError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {ArticleTypeError}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Published{" "}
                      </label>
                      <div className="col-md-7">
                        <select
                          class="default-select2 form-control"
                          value={IsPublished}
                          onChange={onChangePublished}
                        >
                          <option value="">Select </option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Article SKU{" "}
                      </label>
                      <div className="input-group col-md-7 p-r-10 p-l-10">
                        <input
                          type="text"
                          className="form-control input-height"
                          value={ArticleSKU}
                          onChange={onChangeArticleSKU}
                        />
                      </div>
                    </div>

                    {rolename === "Admin" || rolename === "SuperAdmin" ? (
                      <div className="form-group row m-b-15 d-flex align-items-center">
                        <label className="col-md-4 col-form-label product-lable">
                          User
                        </label>

                        <div className="col-md-7">
                          <Select
                            search
                            options={subuserlist}
                            value={selectuserID}
                            onChange={(e) => {
                              setselectuseronlyID(e.value);
                              setselectuserID(e);
                            }}
                            placeholder="Choose login user"
                          />
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </fieldset>
                </form>
              </div>
            </div>
            <div className="row  justify-content-center">
              <button
                type="button"
                className="btn btn-primary search-btn d-flex align-items-center mr-2"
                onClick={SearchFilter}
              >
                <i className="fas fa-lg fa-fw m-r-10 fa-search "></i>
                Search
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={(e) => {
                  ClereHedersearch(e);
                }}
              >
                Reset
              </button>
             
            </div>
          </PanelBody>
        </Panel> */}
        <Panel>
          <PanelHeader>
            <h5 className="text-light mb-0">My QR Code</h5>
          </PanelHeader>
          <hr class="m-0" />
          <PanelBody>
            <div className="row">
              <div className="col-xl-6 d-flex align-items-center">
                <div className="form-group  d-flex mb-0 m-r-10 align-items-center">
                  <label className="col-md-6 col-form-label p-0">All</label>
                  <input
                    type="email"
                    className="form-control col-md-6"
                    id="exampleInputEmail2"
                    onKeyUp={(e) => {
                      ArticleDetailsSearch(e.target.value);
                    }}
                    // placeholder={"(" + TotalCount + ")"}
                    placeholder={TotalCount}
                  />
                </div>
                <div className="form-group  d-flex mb-0 m-r-10 align-items-center">
                  <label className="col-md-6 col-form-label p-0">
                    {" "}
                    Published
                  </label>
                  <input
                    type="email"
                    className="form-control col-md-6"
                    id="exampleInputEmail2"
                    onKeyUp={(e) => {
                      ArticleDetailsSearch(e.target.value);
                    }}
                    // placeholder={"(" + TotalCount + ")"}
                    placeholder={TotleCountPublished}
                  />
                </div>
                <div className="display">
                  <select
                    className="form-control"
                    value={PerPageCount}
                    onChange={(e) => {
                      handlePageCountChange(Number(e.target.value));
                    }}
                  >
                    {PaggingList.map((pageSize, i) => {
                      return pageSize == TotalCount ? (
                        <option key={i} value={pageSize}>
                          Show All
                        </option>
                      ) : (
                        <option key={i} value={pageSize}>
                          Show {pageSize}
                        </option>
                      );

                    })}
                  </select>
                </div>
              </div>
            </div>
            <div class="table-responsive mt-3">
              <table
                class="table table-bordered table-striped text-center"
                {...getTableProps()}
              >
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr
                      {...headerGroup.getHeaderGroupProps()}
                      style={{ textAlign: "center" }}
                    >
                      {headerGroup.headers.map((column) => (
                        <th
                          className="align-middle"
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                        >
                          <div
                            class="d-flex table-header"
                            style={{ minWidth: "" }}
                          >
                            <span>{column.render("Header")}</span>
                            <span
                              class=""
                              onClick={(e) => {
                                handleColumnSort(column);
                              }}
                            >
                              {column.sortable ? (
                                SortColumn === column.selector ? (
                                  SortColumnType == "Desc" ? (
                                    <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
                                  ) : (
                                    <i className="fa fa-sort-up fa-fw f-s-14 text-blue"></i>
                                  )
                                ) : (
                                  <i className="fa fa-sort fa-fw f-s-14 opacity-3"></i>
                                )
                              ) : (
                                ""
                              )}

                            </span>
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row, i) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => {
                          return (
                            <td
                              {...cell.getCellProps()}
                              className="align-middle"
                            >
                              {cell.render("Cell")}{" "}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div class="d-flex align-items-center justify-content-between flex-wrap ">
              <div>
                Showing{" "}
                <strong>
                  {CurrentPageNo} of {Math.ceil(TotalCount / PerPageCount)}
                </strong>{" "}
                Pages
              </div>

              <ul class="pagination justify-content-end flex-wrap align-items-center mt-3">
                <li class="page-item">
                  {canPreviousPage == true ? (
                    <button
                      class="page-link mr-2"
                      href="javascript:void(0);"
                      onClick={() => gotoPage(0)}
                    >
                      Previous
                    </button>
                  ) : (
                    <button
                      class="page-link mr-2"
                      href="javascript:void(0);"
                      disabled={true}
                    >
                      Previous
                    </button>
                  )}
                </li>

                {PaginationGroupList.map((item, index) => (
                  <li>
                    <button
                      key={index}
                      onClick={(e) => {
                        changePage(e);
                      }}
                      className={`btn ml-2 ${CurrentPageNo === item ? "page-link-1" : "btn-white"
                        }`}
                    >
                      <span>{item}</span>
                    </button>
                  </li>
                ))}

                <li class="page-item ml-2">
                  {canNextPage == true ? (
                    <button
                      class="page-link"
                      href="javascript:void(0);"
                      onClick={() => nextPage()}
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      class="page-link"
                      href="javascript:void(0);"
                      disabled={true}
                    >
                      Next
                    </button>
                  )}
                </li>
              </ul>
            </div>
          </PanelBody>
        </Panel>

      </div>
      <Modal
        isOpen={PreviewModalisOpen}
        toggle={PreviewModalisOpen}
        onHide={() => {
          togglepreviewModal("");
        }}
        className="modal-size"
        size="xl">

        <ModalHeader toggle={() => { togglepreviewModal("") }} className="modalheader">
          <h4 className="text-white mb-0">Preview Theme</h4>
        </ModalHeader>
        <ModalBody style={{ overflowY: 'scroll', scrollbarWidth: 'none', MsOverflowStyle: 'none' }}>

          <div className='row px-3' style={{ height: '765px', overflow: 'hidden' }}>

            <div className='col-xl-6' style={{ overflowY: "scroll", flex: 1, height: '750px' }}>
              <div className="row " >

                <dv className=" mt-2 color-picker-main">
                  <b><h5 style={{ color: 'black' }}>Select Theme </h5></b>
                  <select
                    className="default-select2 form-control col-xl-6" onChange={(e) => { selectdefaultTheme(e) }} value={defaultThemeId}>
                    {defaultThemelist?.length > 0 ? defaultThemelist?.map(
                      (item) => {
                        return <option value={item?.value}>
                          {item.label}
                        </option>
                      }) : <></>}
                  </select>
                </dv>

                <div className="" style={{ marginTop: "40px" }}>
                  <b><h5 style={{ color: 'black' }}>Select Page Background Type </h5></b>
                  <div className="d-flex align-items-center">
                    <div className="mt-2" >
                      <input
                        type="radio"
                        value="color"
                        checked={IsBackgroundUrl == false ? true : false}
                        onChange={(e) => { handleOptionChangecolor(e) }}
                      />
                      <label className="ml-2">Colour</label>
                    </div>
                    <div className="ml-3 mt-2">
                      <input
                        type="radio"
                        value="image"
                        checked={IsBackgroundUrl == true ? true : false}
                        onChange={(e) => { handleOptionChange(e) }}
                      />
                      <label className="ml-2">Image</label>
                    </div>
                  </div>
                </div>

                {IsBackgroundUrl === false ?
                  <div className="color-picker-main" style={{ marginTop: "40px" }}>
                    <b><h5 style={{ color: 'black' }}>Select Background Colour </h5></b>
                    <div className="d-flex align-items-center">
                      <ColorPicker
                        inputId="page-text-color"
                        format="hex"
                        value={Color2}
                        // hideInput={["rgb", "hsv"]}
                        // color={Color2} 
                        onChange={(e) => { handleColor2(e) }}
                        className="mb-3 color-picker-custom"
                      />
                    </div>
                  </div>
                  : <></>}

                {IsBackgroundUrl === true ?
                  <div className="color-picker-main" style={{ marginTop: "40px" }}>
                    <b><h5 style={{ color: 'black' }}>Select Background Image</h5></b>
                    <div className="d-flex flex-column align-items-center custom-file file-upload-height">
                      {/* <input type="file" onChange={(e) => { uploadBackgroundImageFile(e) }}  accept="image/x-png, image/gif, image/jpeg" max-size="2000"></input> */}

                      <input type="file" onChange={(e) => { uploadBackgroundImageFile(e) }} accept="image/x-png, image/gif, image/jpeg" max-size="2000" className="custom-file-input file-upload-height" />
                      <label className=" file-upload-1 file-upload-height" for="customFile ">
                        {
                          (uploadBackgroundImage != null && uploadBackgroundImage != undefined && uploadBackgroundImage != "") ?
                            <img
                              alt=""
                              src={Color2}
                              className="width-70 height-70 f-s-20 text-center rounded "

                            /> : Color2 ?
                              <img
                                alt=""
                                src={Config.contentUrl + Color2}
                                className="width-70 height-70 f-s-20 text-center rounded "
                              />
                              :
                              <img
                                alt=""
                                //src="../assets/img/new-images/images.png"
                                src={Config.contentUrlApi + "Frontend/images.png"}
                                className="width-70 height-70 f-s-20 text-center rounded "

                              />
                        }
                        <div className="file-upload-2 "><i className="ion ion-md-camera "></i></div>
                      </label>
                    </div>
                  </div>
                  : <></>}

                <div className="color-picker-main" style={{ marginTop: "40px" }}>
                  <b><h5 style={{ color: 'black' }}>Select Header And Button Colour</h5></b>
                  <div className="d-flex align-items-center">
                    <ColorPicker inputId="header-bg-color" format="hex" value={Color1}
                      onChange={(e) => {
                        handleColor1(e)
                      }} className="mb-3 color-picker-custom" />
                  </div>
                </div>

                <div className="color-picker-main " style={{ marginTop: "40px" }}>
                  <b><h5 style={{ color: 'black' }}>Select Tabs And Button Text Colour</h5></b>
                  <div className="d-flex align-items-center">
                    <ColorPicker inputId="page-text-color" format="hex" value={Color3}
                      onChange={(e) => {
                        //handlePageTextColorChange(e)
                        handleColor3(e)
                      }} className="mb-3 color-picker-custom" />
                  </div>
                </div>


              </div>
              <div className="container-fluid mt-3">
                <div className="row justify-content-center pb-3">
                  <button
                    type="button"
                    class="btn btn-success me-1 mb-1 shadow-add border-0"
                    onClick={(e) => {
                      //alert("Coming soon")
                      addupdateProductQrcodeTheme(e)
                    }}
                  >
                    {isbuttonLoading && (
                      <i class="fa fa-spinner fa-spin m-r-10"></i>
                    )}
                    Save changes

                  </button>
                </div>
              </div>
              {issuccess && <p style={{
                color: "green",
                fontfamily: "Nunito Sans",
                fontweight: "900",
                fontsize: "40px",
                marginbottom: "10px"
              }} > <strong>saved successfully! </strong> </p>}
              {iserror && <p style={{
                color: 'red',
                fontfamily: "Nunito Sans",
                fontweight: "900",
                fontsize: "40px",
                marginbottom: "10px"
              }}> <strong>Sorry! not saved correctly, please Try again </strong> </p>}
            </div>

            <div className='col-xl-6 d-flex  justify-content-center overflow-auto' style={{ position: 'sticky', top: 0, flex: 1 }}  >
              <img src={Config.contentUrlApi + "Frontend/iphone-frame.png"} style={{ position: 'absolute', width: '360px' }} />
              <div className="mobile-preview" style={{ height: '687px', width: '340px', overflowY: 'scroll', marginTop: '60px', borderBottomLeftRadius: 40, borderBottomRightRadius: 40, position: 'relative', zIndex: 9999 }}>
                <Theme
                  titlefontsize={titlefontsizeFinal}
                  descriptionfontsize={descriptionfontsizeFinal}
                  ckeditorTitleFontSize={ckeditorTitleFontSizeFinal}
                  ckeditorDescriptionFontSize={ckeditorDescriptionFontSizeFinal}
                  color1={Color1}
                  color2={Color2}
                  color3={Color3}
                  isBackgroundUrl={IsBackgroundUrl}
                  Productinfo={productinfo}
                  onClickCollapse={onClickCollapse}
                  selectcollapseidlist={Collapseidlist}
                  sliderimground={Sliderimground}
                  LogoshadowFinal={logoshadowFinal}
                  Iscertificatesopen={iscertificatesopen}
                  IscertificatesClick={(e) => { OnIscertificatesClick(e) }}
                  uploadBackgroundImage={uploadBackgroundImage}
                />
              </div>
            </div>

          </div>
        </ModalBody>
      </Modal >


      <Modal
        isOpen={variationlistmodal}
        toggle={ProductVariations}
        className="lg-modal-size"
        onHide={() => {
          ProductVariations("");
        }}
      >
        <ModalHeader toggle={ProductVariations} className="modalheader">
          <h4 className="text-white mb-0">Article Variations</h4>
        </ModalHeader>
        <ModalBody>
          <div>
            {ArticlesVariationList.length > 0 ? (
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <h3 className="mb-0">Article variations</h3>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex justify-content-md-end justify-content-sm-start">
                      <div className="btns btn-group  mr-2  mb-1">
                        <button
                          className="btn btn-green"
                          //   onClick={(e) => {
                          //     Exportvariations();

                          //   }}
                          onClick={async (e) => {
                            try {
                              let response = await Checkexportdata();
                              if (response === true || response === "true") {
                                Exportvariations();
                              } else {
                                swal(
                                  "oops!",
                                  "Sorry! to increase your export data enabled   .",
                                  "warning"
                                );
                              }
                            } catch (error) {
                              console.log("error!", error);
                            }
                          }}
                        >
                          <i class="fas  fa-sm fa-fw m-r-5 fa-download icon"></i>
                          Export
                        </button>
                      </div>

                      {/* <input type="file" id="file" style={{ display: "none" }} />
                                            <button type="button" className="btn mr-2 btn-darkgreen mb-1">
                                                <i className="far fa-lg fa-fw m-r-5 fas fa-file-import icon"></i>
                                                Import
                                            </button> */}

                      {/* <button type="button" className="btns btn  btn-danger  mr-2 mb-1" >
                                                <i className="far fa-lg fa-fw m-r-5 fa-trash-alt icon"></i>
                                                Delete (selected)
                                            </button> */}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="row align-items-center py-3">
                      <div className="col-sm-8">
                        <div className="table-responsive  table-borderless ">
                          <table className="table m-b-0">
                            <tbody>
                              <tr>
                                <td className="bold">Name</td>
                                <td>{ArticlesName}</td>
                              </tr>
                              <tr>
                                <td className="bold">Article No.</td>
                                <td>{ArticlesNo}</td>
                              </tr>
                              <tr>
                                <td className="bold">Category</td>
                                <td>{ArticlescategoryName}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="variationsimg">
                          <img
                          
                            src={ArticlesProfileImage}
                            className="img-fluid"
                            style={{ height: "140px" }}
                            // onError={({ currentTarget }) => {
                            //   currentTarget.onerror = null; // prevents looping
                            //   currentTarget.src =
                            //     "../assets/img/new-images/images.png";
                            // }}
                          ></img>
                        </div>
                        {/* <img src="../assets/img/user/user-1.jpg" /> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6"></div>
                </div>
              </div>
            ) : (
              <></>
            )}
            <DataTable
              //title=" Article Variation"
              columns={columnsVariant}
              data={ArticlesVariationList}
              defaultSortFieldId={2}
              // sortIcon={<SortIcon />}
              sortIcon={
                <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
              }
              pagination
              selectableRows
              //selectedRows
              onSelectedRowsChange={handleChange}
              customStyles={customStyles}
              //onRowClicked
              //className='table'
              theme="solarized"
              striped
            />
          </div>
          {/* <VariationList /> */}

          {/* <VariationListDatatable /> */}
        </ModalBody>
      </Modal>

      <Modal isOpen={modalArticleQroce} toggle={toggleArticle}>
        <ModalHeader toggle={toggleArticle} className="modalheader">
          <h5 className="text-white mb-0">Article QR code </h5>
        </ModalHeader>
        <ModalBody>
          <div className="row justify-content-center mt-2">
            <div className="col-xs-8 text-center  titlebgcontainer mb-4">
              <h5 className="mb-0 text2line">{QrcodeProductname}</h5>
            </div>
          </div>

          <div className="d-flex justify-content-center mt-2">
            {/* <img src="../assets/img/user/QR.png" alt="img" style={{ maxHeight: '250px' }} onerror="this.src='../assets/img/new-images/images.png';"></img> */}
            <QRCode value={Qrcodestring} id="qrCodeEl" size={210} />
          </div>

          <div className="d-flex justify-content-center mt-4">
            <button
              type="submit"
              className="btn btn-warning  m-r-5 m-b-5"
              onClick={() => {
                printQrcode();
              }}
            >
              Print
            </button>
            <button
              type="submit"
              className="btn btn-warning m-b-5 m-r-5"
              onClick={() => {
                downloadQRCodeArticle();
              }}
            >
              Download
            </button>
            <button
              type="submit"
              className="btn btn-warning m-r-5 m-b-5"
              onClick={() => {
                toggleToEmail();
              }}
            >
              Send
            </button>

            {/* <EmailShare subject="Qrcode" body={Qrcodestring} attachment={"http://png-2.findicons.com/files/icons/573/must_have/48/mail.png"}>
                            {link => (
                                <a href={link} data-rel="external"><button type="submit" className="btn btn-warning m-b-5 ">Send</button></a>
                            )}
                        </EmailShare> */}
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={QrCodeModalisOpen}
        toggle={QrCodeModalisOpen}
        className="modal-size"
      >
        <ModalHeader toggle={toggleQrCodeModal} className="modalheader">
          <h4 className="text-white mb-0">Create QR code</h4>
        </ModalHeader>
        <ModalBody>
          <div className="row px-3">
            <div className="col-xl-6">
              <div className="row  align-items-center">
                <div className="col-xl-4 ">
                  {ArticlesProfileImage !== null &&
                    ArticlesProfileImage !== undefined &&
                    ArticlesProfileImage !== "" ? (
                    <img
                      src={ArticlesProfileImage}
                      alt
                      width="100%"
                      className="rounded"
                    />
                  ) : (
                    <img
                      src="../assets/img/user/noimage.jpg"
                      alt
                      width="100%"
                      className="rounded"
                    />
                  )}
                  <h5 className="m-t-10 mb-0 text-center">{ArticleName}</h5>
                </div>
              </div>
              <div className="m-t-30">
                <div className="row">
                  <h5 className="col-xl-4 mb-0">
                    <b>Article</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6"> {ArticlesNo} </p>
                </div>
                <div className="row">
                  <h5 className="col-xl-4 mb-0">
                    <b>Category</b>
                  </h5>
                  <p>:</p>
                  <p className="col-xl-6">{ArticlescategoryName}</p>
                </div>
                <form action="javascript:void(0);" method="POST">
                  <fieldset>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-xl-4 col-form-label">
                        <h5 className="mb-0">
                          <b>Combination</b>
                        </h5>
                      </label>
                      <div>:</div>
                      <div className="col-xl-7">
                        <p className="mb-0">{selectCombination}</p>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>

              {
                // CombinationList.length > 0 ?
                selectCombinationID != "" &&
                  selectCombinationID != undefined &&
                  selectCombinationID != null ? (
                  QrCodeString != null &&
                    QrCodeString != undefined &&
                    QrCodeString != "" ? (
                    <button
                      type="button"
                      className="btn btn-primary shadow-add my-3 m-l-10 m-r-10 btn-lg"
                      onClick={() => {
                        QrcodeCombinationalredycreate();
                      }}
                    >
                      Create QR Code
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={async (e) => {
                        let response =
                          await CheckCheckAPDynamicQrCodeCountenabled();

                        if (response === true) {
                          Qrcodegenerator(e);
                        } else {
                          swal(
                            "oops!",
                            "Sorry! to increase your dynamic qrcode count.",
                            "warning"
                          );
                        }
                      }}
                      className="btn btn-primary shadow-add my-3 m-l-10 m-r-10 btn-lg"
                    >
                      Create QR Code
                    </button>
                  )
                ) : (
                  // <button type="button" onClick={() => { Qrcodegenerator() }} className="btn btn-primary shadow-add my-3 m-l-10 m-r-10">Create QR Code</button>
                  <></>
                )
              }

              <button
                type="button"
                onClick={() => {
                  toggleQrCodeModal();
                }}
                className="btn btn-danger btn-lg shadow-add my-3 "
              >
                Discard
              </button>
            </div>
            <div className="col-xl-6">
              <div className="dash-box">
                {/* <img src="../assets/img/user/QR.png" style={{ height: '350px' }}></img> */}
                <div style={{ background: "white", padding: "16px" }}>
                  {selectCombinationID != "" &&
                    selectCombinationID != undefined &&
                    selectCombinationID != null ? (
                    QrCodeString != null &&
                      QrCodeString != undefined &&
                      QrCodeString != "" ? (
                      <QRCode value={QrCodeString} id="qrCodeEl1" size={210} />
                    ) : (
                      <img
                        src="/assets/img/new-Images/qr-code-scanner.jpg"
                        style={{ height: "210px" }}
                      ></img>
                    )
                  ) : (
                    // <img src="/assets/img/new-Images/qr-code-scanner.jpg" style={{ height: '210px' }}></img>
                    <></>
                  )}
                </div>

                <div className="my-2">
                  {selectCombinationID != "" &&
                    selectCombinationID != undefined &&
                    selectCombinationID != null ? (
                    QrCodeString != null &&
                      QrCodeString != undefined &&
                      QrCodeString != "" ? (
                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-warning  m-r-5 m-b-5 "
                          onClick={(e) => {
                            printQrcodeAttributecreate(e);
                          }}
                        >
                          Print{" "}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-b-5 m-r-5 "
                          onClick={(e) => {
                            downloadQRCodeAttributecreate(e);
                          }}
                        >
                          Download
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-b-5 "
                          onClick={() => {
                            toggleToEmailAttributecreate();
                          }}
                        >
                          Send
                        </button>
                      </div>
                    ) : (
                      <></>
                    )
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={isToEamil} toggle={toggleToEmail}>
        <ModalHeader toggle={toggleToEmail} className="modalheader">
          <h5 className="text-white mb-0">To Email</h5>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <label
              htmlFor="exampleInputPassword1"
              className="mt-2 d-flex align-items-center"
            >
              <h5 className="mb-0">Add To Email</h5>
              <button
                type="button"
                className="m-l-10 btn btn-link"
                onClick={SubToEmailaddClick}
              >
                <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
              </button>
            </label>
          </div>
          <div className="form-group">
            {createSubToEmailUI()}
            {isToemailMaltiple === true ? (
              <span style={{ color: "red", marginLeft: 6 }}>
                {"Email id dublicate"}
              </span>
            ) : (
              <></>
            )}
            {ToemailEmptyError.length > 0 && (
              <span style={{ color: "red", marginLeft: 6 }}>
                {ToemailEmptyError}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={() => {
                QRCodeArticleSend();
              }}
              className="btn btn-sm btn-primary m-r-5 shadow-add "
            >
              Send Email
            </button>
            <button
              type="button"
              onClick={() => {
                toggleToEmail();
              }}
              className="btn btn-sm btn-danger shadow-add "
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={isToEamilAttribute} toggle={toggleToEmailAttributecreate}>
        <ModalHeader
          toggle={toggleToEmailAttributecreate}
          className="modalheader"
        >
          <h5 className="text-white mb-0">To Email</h5>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12">
            <label
              htmlFor="exampleInputPassword1"
              className="mt-2 d-flex align-items-center"
            >
              <h5 className="mb-0">Add To Email</h5>
              <button
                type="button"
                className="m-l-10 btn btn-link"
                onClick={SubToEmailaddClick}
              >
                <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
              </button>
            </label>
          </div>
          <div className="form-group">
            {createSubToEmailUI()}
            {isToemailMaltiple === true ? (
              <span style={{ color: "red", marginLeft: 6 }}>
                {"Email id dublicate"}
              </span>
            ) : (
              <></>
            )}
            {ToemailEmptyError.length > 0 && (
              <span style={{ color: "red", marginLeft: 6 }}>
                {ToemailEmptyError}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="button"
              onClick={() => {
                QRCodeArticleSendAttributecreate();
              }}
              className="btn btn-sm btn-primary m-r-5 shadow-add "
            >
              Send Email
            </button>
            <button
              type="button"
              onClick={() => {
                toggleToEmailAttributecreate();
              }}
              className="btn btn-sm btn-danger shadow-add "
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
const customStyles = {
  title: {
    style: {
      fontColor: "red",
      fontWeight: "400",
    },
  },
  rows: {
    style: {
      minHeight: "67px", // override the row height
      borderWidth: 1,
      borderColor: "#e4e7ea",
    },
  },
  headCells: {
    style: {
      fontSize: "15px",
      fontWeight: "600",
    },
  },
  cells: {
    style: {
      fontSize: "15px",
      fontWeight: "400",
    },
  },
};

export default ArticleQRCode;
